export default {
  translation: {
    // Common
    "app.name": "Give Protocol",
    "app.tagline": "उदारता के लिए पारदर्शी, सीमाहीन अवसंरचना।",
    "common.skipToMainContent": "मुख्य सामग्री पर जाएं",
    "common.cancel": "रद्द करें",
    "common.edit": "संपादित करें",
    "common.delete": "हटाएं",
    "common.creating": "बना रहे हैं...",
    "common.unknown": "अज्ञात",
    "common.notAvailable": "उपलब्ध नहीं",

    // Navigation
    "nav.browse": "चैरिटी ब्राउज़ करें",
    "nav.opportunities": "स्वयंसेवक अवसर",
    "nav.contributions": "योगदान ट्रैकर",
    "nav.governance": "शासन",
    "nav.dashboard": "Give डैशबोर्ड",
    "nav.about": "हमारे बारे में",
    "nav.docs": "दस्तावेज़",
    "nav.legal": "कानूनी",
    "nav.launchApp": "ऐप लॉन्च करें",

    // FAQ page (GIV-988)
    "faq.title": "अक्सर पूछे जाने वाले प्रश्न",
    "faq.subtitle":
      "दान, स्वयंसेवा और ब्लॉकचेन पारदर्शिता के बारे में आपको जो कुछ भी जानना चाहिए।",

    // Settings
    "settings.title": "सेटिंग्स",
    "settings.language": "भाषा",
    "settings.currency": "मुद्रा",

    // Auth
    "auth.login": "साइन इन करें",
    "auth.register": "खाता बनाएं",
    "auth.logout": "साइन आउट करें",
    "auth.forgotPassword": "पासवर्ड भूल गए?",

    // Dashboard
    "dashboard.title": "Give डैशबोर्ड",
    "dashboard.subtitle": "अपने दान और स्वयंसेवक योगदान को ट्रैक करें",
    "dashboard.totalDonations": "कुल दान",
    "dashboard.volunteerHours": "स्वयंसेवक घंटे",
    "dashboard.skillsEndorsed": "अनुमोदित कौशल",
    "dashboard.contributions": "योगदान",
    "dashboard.yourTotalDonated": "आपका कुल दान",
    "dashboard.yourVolunteerHours": "आपके स्वयंसेवक घंटे",
    "dashboard.yourSkillsEndorsed": "आपके अनुमोदित कौशल",
    "dashboard.impactGrowth": "प्रभाव वृद्धि",
    "dashboard.charitiesSupported": "समर्थित चैरिटी",

    // Charity
    "charity.dashboard": "चैरिटी डैशबोर्ड",
    "charity.subtitle": "अपने दान और स्वयंसेवक कार्यक्रमों का प्रबंधन करें",
    "charity.activeVolunteers": "सक्रिय स्वयंसेवक",
    "charity.transactions": "लेनदेन",
    "charity.volunteers": "स्वयंसेवक घंटे",
    "charity.applications": "आवेदन",
    "charity.totalReceived": "कुल प्राप्त",
    "charity.equityPoolValue": "इक्विटी पूल मूल्य",
    "charity.availableBalance": "उपलब्ध शेष",

    // Contributions
    "contributions.date": "तिथि",
    "contributions.type": "प्रकार",
    "contributions.organization": "संगठन",
    "contributions.details": "विवरण",
    "contributions.status": "स्थिति",
    "contributions.verification": "सत्यापन",
    "contributions.export": "CSV निर्यात करें",

    // Volunteer
    "volunteer.opportunities": "स्वयंसेवक अवसर",
    "volunteer.searchOpportunities": "अवसर खोजें...",
    "volunteer.selectSkill": "कौशल चुनें",
    "volunteer.selectType": "प्रकार चुनें",
    "volunteer.selectLanguage": "भाषा चुनें",
    "volunteer.allSkills": "सभी कौशल",
    "volunteer.allTypes": "सभी प्रकार",
    "volunteer.allLanguages": "सभी भाषाएं",
    "volunteer.applyNow": "अभी आवेदन करें",
    "volunteer.noOpportunitiesFound":
      "आपके मानदंड से मेल खाते कोई अवसर नहीं मिले।",
    "volunteer.verify": "घंटे सत्यापित करें",
    "volunteer.verifying": "सत्यापित हो रहा है...",
    "volunteer.reject": "अस्वीकार करें",
    "volunteer.accept": "स्वीकार करें",
    "volunteer.processing": "प्रसंस्करण हो रहा है...",
    "volunteer.hours": "घंटे",
    "volunteer.description": "विवरण",
    "volunteer.appliedFor": "इसके लिए आवेदन किया",
    "volunteer.verificationComplete": "सत्यापन पूर्ण",
    "volunteer.hoursVerified":
      "स्वयंसेवक घंटों को सत्यापित किया गया है और ब्लॉकचेन पर दर्ज किया गया है।",
    "volunteer.verificationHash": "सत्यापन हैश",
    "volunteer.applicationAccepted": "आवेदन स्वीकृत",
    "volunteer.applicationRecorded":
      "स्वयंसेवक आवेदन स्वीकार किया गया है और ब्लॉकचेन पर दर्ज किया गया है।",
    "volunteer.acceptanceHash": "स्वीकृति हैश",
    "volunteer.pendingHours": "लंबित स्वयंसेवक घंटे",
    "volunteer.noPendingHours":
      "सत्यापन के लिए कोई लंबित स्वयंसेवक घंटे नहीं हैं।",
    "volunteer.pendingApplications": "लंबित आवेदन",
    "volunteer.noPendingApplications":
      "समीक्षा के लिए कोई लंबित आवेदन नहीं हैं।",
    "volunteer.createOpportunity": "स्वयंसेवक अवसर बनाएं",
    "volunteer.createNew": "नया बनाएं",
    "volunteer.noOpportunitiesYet":
      'अभी तक कोई अवसर नहीं बनाया गया है। शुरू करने के लिए "नया बनाएं" पर क्लिक करें।',
    "volunteer.opportunityTitle": "अवसर शीर्षक",
    "volunteer.skills": "कौशल (अल्पविराम से अलग)",
    "volunteer.commitment": "प्रतिबद्धता",
    "volunteer.location": "स्थान",
    "volunteer.type": "प्रकार",
    "volunteer.workLanguage": "कार्य भाषा",
    "volunteer.status": "स्थिति",

    // Volunteer commitment types
    "volunteer.commitment.oneTime": "एक बार",
    "volunteer.commitment.shortTerm": "अल्पकालिक",
    "volunteer.commitment.longTerm": "दीर्घकालिक",

    // Volunteer types
    "volunteer.type.remote": "रिमोट",
    "volunteer.type.onsite": "स्थल पर",
    "volunteer.type.hybrid": "हाइब्रिड",
    "volunteer.type.onSite": "स्थल पर",

    // Volunteer - Opportunities page
    "volunteer.workTypeFilter": "कार्य प्रकार फ़िल्टर",
    "volunteer.searchLocation": "शहर या क्षेत्र...",
    "volunteer.searchLocationAria": "स्थान खोजें",
    "volunteer.filter.skill": "कौशल: {{value}}",
    "volunteer.filter.type": "प्रकार: {{value}}",
    "volunteer.filter.language": "भाषा: {{value}}",
    "volunteer.filter.location": "स्थान: {{value}}",
    "volunteer.loadingOpportunities": "अवसर लोड हो रहे हैं...",
    "volunteer.loadOpportunitiesError": "स्वयंसेवा अवसर लोड नहीं हो सके। कृपया बाद में पुनः प्रयास करें।",
    "volunteer.viewDetails": "विवरण देखें",
    "volunteer.backToOpportunities": "अवसरों पर वापस जाएँ",
    "volunteer.detail.about": "इस अवसर के बारे में",
    "volunteer.detail.skills": "आवश्यक कौशल",
    "volunteer.detail.commitment": "समय प्रतिबद्धता",
    "volunteer.detail.location": "स्थान",
    "volunteer.detail.language": "भाषा",
    "volunteer.detail.hostedBy": "आयोजक",
    "volunteer.detail.ongoing": "निरंतर",
    "volunteer.detail.applicationsClosed": "आवेदन बंद",
    "volunteer.detail.notFoundTitle": "अवसर नहीं मिला",
    "volunteer.detail.notFoundMessage": "हो सकता है यह अवसर भर गया हो या हटा दिया गया हो।",
    "volunteer.field.requirements": "आवश्यकताएँ",
    "volunteer.field.benefits": "लाभ",
    "volunteer.field.schedule": "समय-सारणी",
    "volunteer.field.schedulePlaceholder": "जैसे: मंगलवार शाम 6-8 बजे, सप्ताहांत लचीला",
    "volunteer.field.startDate": "आरंभ तिथि",
    "volunteer.field.endDate": "समाप्ति तिथि",
    "volunteer.field.endDateHelp": "निरंतर हो तो खाली छोड़ें",
    "volunteer.field.applicationDeadline": "आवेदन की अंतिम तिथि",
    "volunteer.field.volunteersNeeded": "आवश्यक स्वयंसेवक",
    "volunteer.field.minimumAge": "न्यूनतम आयु",
    "volunteer.field.backgroundCheckRequired": "पृष्ठभूमि जाँच आवश्यक",
    "volunteer.field.trainingProvided": "प्रशिक्षण उपलब्ध",
    "volunteer.field.onePerLine": "प्रति पंक्ति एक",
    "volunteer.validation.volunteersNeeded": "1 या अधिक की संख्या दर्ज करें",
    "volunteer.validation.minimumAge": "0 से 120 के बीच की आयु दर्ज करें",
    "volunteer.validation.endDate": "समाप्ति तिथि आरंभ तिथि के बराबर या बाद की होनी चाहिए",
    "volunteer.signInToApply":
      "स्वयंसेवक अवसरों के लिए आवेदन करने हेतु कृपया साइन इन करें",
    "volunteer.applicationSuccess": "आवेदन सफलतापूर्वक जमा किया गया!",
    "volunteer.removeFilter": "{{filter}} फ़िल्टर हटाएं",

    // Volunteer - OpportunityForm
    "volunteer.validation.titleRequired": "शीर्षक आवश्यक है",
    "volunteer.validation.descriptionRequired": "विवरण आवश्यक है",
    "volunteer.validation.skillsRequired": "कम से कम एक कौशल आवश्यक है",
    "volunteer.validation.locationRequired": "स्थान आवश्यक है",
    "volunteer.profileNotFound": "उपयोगकर्ता प्रोफ़ाइल नहीं मिली",
    "volunteer.correctErrors": "कृपया सत्यापन त्रुटियों को सही करें",
    "volunteer.createFailed": "अवसर बनाने में विफल",
    "volunteer.descriptionPlaceholder":
      "स्वयंसेवक अवसर का विस्तृत विवरण दें...",
    "volunteer.skillsPlaceholder": "जैसे, वेब विकास, परियोजना प्रबंधन, अनुवाद",
    "volunteer.locationPlaceholder": "जैसे, रिमोट, नई दिल्ली, मुंबई",
    "volunteer.headerImage": "हेडर छवि",
    "volunteer.headerImageHelp":
      "अपनी अवसर सूची के शीर्ष पर प्रदर्शित करने के लिए एक छवि अपलोड करें",
    "volunteer.limitReached": "अवसर सीमा पूर्ण",
    "volunteer.limitReachedMessage":
      "आपने अधिकतम {{max}} सक्रिय स्वयंसेवक अवसरों की सीमा पूरी कर ली है। कृपया नया बनाने से पहले किसी मौजूदा अवसर को बंद करें या पूरा करें।",
    "volunteer.opportunityCount":
      "आपके {{max}} में से {{count}} सक्रिय अवसर हैं।",

    // Volunteer - HoursVerificationTab
    "volunteer.hoursVerification": "घंटों का सत्यापन",
    "volunteer.hoursVerificationDescription":
      "स्वयंसेवक घंटों की प्रस्तुतियों की समीक्षा और सत्यापन करें",
    "volunteer.formalHours": "दर्ज किए गए घंटे",
    "volunteer.selfReported": "स्व-रिपोर्टेड",
    "volunteer.loggedHours": "दर्ज किए गए स्वयंसेवक घंटे",
    "volunteer.loggedHoursDescription":
      "आपके अवसरों के माध्यम से स्वयंसेवकों द्वारा दर्ज किए गए घंटे",
    "volunteer.allCaughtUp": "सब अद्यतन है!",
    "volunteer.noPendingLoggedHours":
      "सत्यापन के लिए कोई लंबित दर्ज घंटे नहीं हैं।",
    "volunteer.selfReportedHours": "स्व-रिपोर्टेड घंटे",

    // Volunteer - OpportunitiesTab
    "volunteer.noOpportunitiesTitle": "अभी कोई अवसर नहीं",
    "volunteer.activeCount": "{{max}} में से {{count}} सक्रिय अवसर",
    "volunteer.moreSkills": "+{{count}} और",

    // Volunteer - ApplicationsTab
    "volunteer.noApplications": "कोई लंबित आवेदन नहीं",
    "volunteer.unknownOpportunity": "अज्ञात अवसर",

    // Volunteer - VerificationLookup
    "volunteer.verifyContribution": "स्वयंसेवक योगदान सत्यापित करें",
    "volunteer.hashPlaceholder": "सत्यापन हैश दर्ज करें",
    "volunteer.searching": "खोज रहे हैं...",
    "volunteer.verifyHash": "हैश सत्यापित करें",
    "volunteer.verificationNotFound": "सत्यापन नहीं मिला",
    "volunteer.verificationNotFoundMessage":
      "आपके द्वारा दिया गया हैश हमारे रिकॉर्ड में नहीं मिला। कृपया हैश की जांच करें और पुनः प्रयास करें।",
    "volunteer.unknownOrganization": "अज्ञात संगठन",

    // Volunteer - VolunteerVerificationCard
    "volunteer.contributionVerification": "स्वयंसेवक योगदान सत्यापन",
    "volunteer.volunteerLabel": "स्वयंसेवक",
    "volunteer.opportunityLabel": "अवसर",
    "volunteer.organizationLabel": "संगठन",
    "volunteer.acceptedOn": "स्वीकृति तिथि",
    "volunteer.verifiedOn": "सत्यापन तिथि",
    "volunteer.verificationHashes": "सत्यापन हैश",
    "volunteer.blockchainReference": "ब्लॉकचेन संदर्भ",

    // Volunteer - VerifyContribution page
    "volunteer.verifyingContribution": "योगदान सत्यापित हो रहा है\u2026",
    "volunteer.noHashProvided": "कोई सत्यापन हैश प्रदान नहीं किया गया।",
    "volunteer.verificationSuccessful": "सत्यापन सफल",
    "volunteer.contributionVerifiedBlockchain":
      "इस स्वयंसेवक योगदान को सत्यापित किया गया है और ब्लॉकचेन पर दर्ज किया गया है।",
    "volunteer.verificationFailed": "सत्यापन विफल",
    "volunteer.hashNotFound": "सत्यापन हैश {{hash}} नहीं मिला या अमान्य है।",

    // Volunteer - SelfReportedHoursDashboard
    "volunteer.volunteerHoursTitle": "स्वयंसेवक घंटे",
    "volunteer.aboutSelfReported": "स्व-रिपोर्टेड घंटों के बारे में",
    "volunteer.selfReportedInfo":
      "केवल सत्यापित संगठनों द्वारा मान्य किए गए घंटे ही वैश्विक प्रभाव रैंकिंग में गिने जाते हैं। हमारे प्लेटफ़ॉर्म पर नहीं मौजूद संगठनों के लिए घंटे ट्रैक किए जा सकते हैं, लेकिन मान्यता प्राप्त होने तक उन्हें \u201cअमान्य\u201d के रूप में चिह्नित किया जाएगा।",
    "volunteer.logHoursButton": "घंटे दर्ज करें",
    "volunteer.logVolunteerHours": "स्वयंसेवक घंटे दर्ज करें",
    "volunteer.editRecord": "रिकॉर्ड संपादित करें",
    "volunteer.recordDetails": "रिकॉर्ड विवरण",
    "volunteer.backToList": "सूची पर वापस जाएं",
    "volunteer.deleteRecord": "रिकॉर्ड हटाएं?",
    "volunteer.deleteConfirmation":
      "क्या आप वाकई इस स्वयंसेवक घंटों के रिकॉर्ड को हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।",

    // Volunteer - SelfReportedHoursForm
    "volunteer.activityType": "गतिविधि प्रकार",
    "volunteer.organization": "संगठन",
    "volunteer.searchRegistry": "रजिस्ट्री खोजें",
    "volunteer.searchRegistryPlaceholder":
      "नाम या कर पहचान संख्या से चैरिटी रजिस्ट्री खोजें…",
    "volunteer.registryTaxId": "कर पहचान संख्या {{value}}",
    "volunteer.notListed": "सूचीबद्ध नहीं",
    "volunteer.organizationName": "संगठन का नाम",
    "volunteer.enterOrgName": "संगठन का नाम दर्ज करें",
    "volunteer.contactEmail": "संपर्क ईमेल",
    "volunteer.contactEmailOptional": "(वैकल्पिक)",
    "volunteer.onboardHelp":
      "हम इस संगठन को जोड़ने में मदद के लिए संपर्क कर सकते हैं",
    "volunteer.submittedForValidation":
      "यह रिकॉर्ड मान्यता के लिए प्रस्तुत किया जाएगा",
    "volunteer.submittedForValidationTo":
      "यह रिकॉर्ड {{org}} को मान्यता के लिए प्रस्तुत किया जाएगा",
    "volunteer.validationExpired":
      "इस तिथि के लिए मान्यता अवधि समाप्त हो गई है",
    "volunteer.savedAsUnvalidated": "यह रिकॉर्ड अमान्य के रूप में सहेजा जाएगा",
    "volunteer.describeActivities":
      "आपने जो गतिविधियां की हैं उनका वर्णन करें...",
    "volunteer.moreCharsNeeded": "{{count}} और अक्षर आवश्यक हैं",
    "volunteer.updating": "अपडेट हो रहा है...",
    "volunteer.logging": "दर्ज हो रहा है...",
    "volunteer.updateHours": "घंटे अपडेट करें",

    // Volunteer - SelfReportedHoursList
    "volunteer.statusFilter": "स्थिति",
    "volunteer.activityTypeFilter": "गतिविधि प्रकार",
    "volunteer.filterFrom": "से",
    "volunteer.filterTo": "तक",
    "volunteer.clearFilters": "फ़िल्टर साफ़ करें",
    "volunteer.allStatuses": "सभी",
    "volunteer.allActivityTypes": "सभी प्रकार",
    "volunteer.noMatchingRecords": "कोई मिलान रिकॉर्ड नहीं",
    "volunteer.noHoursLogged": "अभी तक कोई स्वयंसेवक घंटे दर्ज नहीं किए गए",
    "volunteer.adjustFilters":
      "रिकॉर्ड खोजने के लिए अपने फ़िल्टर समायोजित करें।",
    "volunteer.startLogging": "अपने पहले स्वयंसेवक घंटे दर्ज करके शुरू करें।",

    // Volunteer - SelfReportedHoursStats
    "volunteer.validatedHours": "मान्य घंटे",
    "volunteer.pendingValidation": "मान्यता लंबित",
    "volunteer.unvalidatedHours": "अमान्य घंटे",
    "volunteer.rejectedLabel": "अस्वीकृत",
    "volunteer.hoursUnit": "घंटे",
    "volunteer.recordSingular": "रिकॉर्ड",
    "volunteer.recordPlural": "रिकॉर्ड",

    // Volunteer - VolunteerApplicationForm
    "volunteer.applicationTitle": "स्वयंसेवक अवसर आवेदन",
    "volunteer.applicationSubtitle":
      "सत्यापित योगदान के माध्यम से सतत प्रभाव बनाने में सहायता करें",
    "volunteer.progress.info": "जानकारी",
    "volunteer.progress.skills": "कौशल",
    "volunteer.progress.consent": "सहमति",
    "volunteer.fieldValid": "ठीक लग रहा है",
    "volunteer.draftSaved": "ड्राफ़्ट सहेजा गया",
    "volunteer.personalInfo": "व्यक्तिगत जानकारी",
    "volunteer.firstName": "पहला नाम",
    "volunteer.lastName": "उपनाम",
    "volunteer.emailAddress": "ईमेल पता",
    "volunteer.phoneNumber": "फ़ोन नंबर",
    "volunteer.locationCity": "स्थान/शहर",
    "volunteer.locationCityPlaceholder": "जैसे, नई दिल्ली, भारत",
    "volunteer.timeZone": "समय क्षेत्र",
    "volunteer.selectTimeZone": "समय क्षेत्र चुनें",
    "volunteer.ageRange": "आयु सीमा",
    "volunteer.selectAgeRange": "आयु सीमा चुनें",
    "volunteer.skillsAndInterests": "कौशल और रुचियां",
    "volunteer.skillsLabel": "कौशल और रुचि के क्षेत्र",
    "volunteer.skillPlaceholderFull":
      "अपने कौशल टाइप करना शुरू करें (जैसे, Python प्रोग्रामिंग, सार्वजनिक भाषण, अनुदान लेखन)",
    "volunteer.skillPlaceholderShort": "कौशल टाइप करें और Enter दबाएं...",
    "volunteer.commitmentLevel": "प्रतिबद्धता स्तर",
    "volunteer.commitmentOneTimeDesc": "एकल परियोजना या अल्पकालिक कार्य",
    "volunteer.commitmentShortTermDesc": "कुछ सप्ताह से कुछ महीने",
    "volunteer.commitmentLongTermDesc":
      "कई महीनों या उससे अधिक की निरंतर प्रतिबद्धता",
    "volunteer.experienceLabel": "अपने प्रासंगिक अनुभव के बारे में बताएं",
    "volunteer.experiencePlaceholder":
      "अपनी पृष्ठभूमि, कौशल, और Give Protocol के साथ स्वयंसेवा करने की प्रेरणा का वर्णन करें...",
    "volunteer.consentTitle": "सहमति और समझौता",
    "volunteer.consentHeader": "स्वयंसेवक आवेदन सहमति",
    "volunteer.submitting": "जमा हो रहा है...",
    "volunteer.submitApplication": "स्वयंसेवक आवेदन जमा करें",
    "volunteer.disclaimerText":
      "यह आवेदन जमा करके, आप स्वीकार करते हैं कि आपने Give Protocol की गोपनीयता नीति और स्वयंसेवक दिशानिर्देशों को पढ़ और समझ लिया है। आपके डेटा को लागू डेटा सुरक्षा विनियमों के अनुसार संसाधित किया जाएगा।",
    "volunteer.validation.firstNameInvalid":
      "कृपया एक मान्य पहला नाम दर्ज करें",
    "volunteer.validation.lastNameInvalid": "कृपया एक मान्य उपनाम दर्ज करें",
    "volunteer.validation.emailInvalid": "कृपया एक मान्य ईमेल पता दर्ज करें",
    "volunteer.validation.phoneInvalid": "कृपया एक मान्य फ़ोन नंबर दर्ज करें",
    "volunteer.validation.experienceRequired":
      "कृपया अपने प्रासंगिक अनुभव का वर्णन करें",
    "volunteer.validation.addSkill": "कृपया कम से कम एक कौशल जोड़ें",
    "volunteer.validation.ageRangeRequired": "कृपया अपनी आयु सीमा चुनें",
    "volunteer.validation.consentRequired":
      "आपको सभी आवश्यक सहमति मदों से सहमत होना होगा",
    "volunteer.signInToSubmit": "आवेदन जमा करने के लिए कृपया लॉग इन करें",
    "volunteer.submitFailed":
      "आवेदन जमा करने में विफल। कृपया पुनः प्रयास करें।",

    // Volunteer - ApplicationForm
    "volunteer.applyForTitle": "इसके लिए आवेदन करें: {{title}}",
    "volunteer.fullName": "पूरा नाम *",
    "volunteer.phoneRequired": "फ़ोन नंबर *",
    "volunteer.emailRequired": "ईमेल पता *",
    "volunteer.dateOfBirth": "जन्म तिथि",
    "volunteer.availabilityTitle": "उपलब्धता",
    "volunteer.preferredDays": "पसंदीदा दिन",
    "volunteer.preferredTimes": "पसंदीदा समय",
    "volunteer.commitmentLevelLabel": "प्रतिबद्धता स्तर",
    "volunteer.skillsAndExperience": "कौशल और अनुभव",
    "volunteer.relevantExperience": "प्रासंगिक अनुभव *",
    "volunteer.certifications": "प्रमाणपत्र (अल्पविराम से अलग)",
    "volunteer.interestsAndPreferences": "रुचियां और प्राथमिकताएं",
    "volunteer.areasOfInterest": "रुचि के क्षेत्र (अल्पविराम से अलग)",
    "volunteer.referencesTitle": "संदर्भ",
    "volunteer.referenceName": "संदर्भ {{index}} नाम",
    "volunteer.referenceContact": "संदर्भ {{index}} संपर्क",
    "volunteer.workSamplesTitle": "कार्य नमूने",
    "volunteer.workSamplesLabel": "कार्य नमूनों के लिंक (अल्पविराम से अलग)",
    "volunteer.submitApplicationShort": "आवेदन जमा करें",
    "volunteer.validation.nameInvalid":
      "कृपया एक मान्य नाम दर्ज करें (2-100 अक्षर)",
    "volunteer.validation.provideExperience":
      "कृपया अपने अनुभव के बारे में जानकारी प्रदान करें",
    "volunteer.validation.selectDay": "कृपया कम से कम एक दिन चुनें",
    "volunteer.validation.selectTime": "कृपया कम से कम एक समय चुनें",

    // Volunteer - ConsentForm
    "volunteer.consentUnderstand": "मैं समझता/समझती हूं कि:",
    "volunteer.processingAckTitle": "प्रसंस्करण की स्वीकृति",
    "volunteer.processingAckDesc":
      "आगे बढ़ने से पहले कृपया निम्नलिखित की समीक्षा करें और स्वीकार करें:",
    "volunteer.essentialProcessingTitle": "आवेदन प्रसंस्करण (पुष्टि आवश्यक):",
    "volunteer.acknowledgmentTitle": "स्वीकृति",
    "volunteer.ageConfirmationTitle": "आयु पुष्टि:",
    "volunteer.privacyNoticeTitle": "गोपनीयता सूचना:",
    "volunteer.doNotAccept": "स्वीकार न करें",
    "volunteer.acceptAndContinue": "स्वीकार करें और जारी रखें",
    "volunteer.validation.essentialRequired":
      "आगे बढ़ने के लिए आपको आवेदन-प्रसंस्करण स्वीकृति की पुष्टि करनी होगी",
    "volunteer.validation.agePrivacyRequired":
      "आपको अपनी आयु की पुष्टि करनी होगी और यह सुनिश्चित करना होगा कि आपने गोपनीयता सूचना पढ़ ली है",

    // Age affirmation gate (shared across all surfaces — GIV-453)
    "ageGate.positive":
      "मैं पुष्टि करता/करती हूँ कि मेरी आयु 16 वर्ष या उससे अधिक है।",
    "ageGate.negative":
      "Give Protocol 16 वर्ष या उससे अधिक आयु के उपयोगकर्ताओं के लिए उपलब्ध है। यदि आपकी आयु 16 वर्ष से कम है, तो हम इस समय आपके अनुरोध को संसाधित करने में असमर्थ हैं।",

    // Languages
    "language.english": "अंग्रेज़ी",
    "language.spanish": "स्पेनिश",
    "language.german": "जर्मन",
    "language.french": "फ़्रेंच",
    "language.japanese": "जापानी",
    "language.chinese_simplified": "चीनी (सरलीकृत)",
    "language.chinese_traditional": "चीनी (पारंपरिक)",
    "language.thai": "थाई",
    "language.vietnamese": "वियतनामी",
    "language.korean": "कोरियाई",
    "language.arabic": "अरबी",
    "language.hindi": "हिन्दी",
    "language.multiple": "एकाधिक भाषाएं",

    // Contribution types
    "contribution.type.donation": "दान",
    "contribution.type.volunteerapplication": "स्वयंसेवक आवेदन",
    "contribution.type.volunteerhours": "स्वयंसेवक घंटे",
    "contribution.type.volunteeracceptance": "स्वयंसेवक स्वीकृति",
    "contribution.type.volunteerverification": "स्वयंसेवक सत्यापन",

    // Donor/Volunteer
    "donor.volunteer": "दाता/स्वयंसेवक",
    "donor.anonymous": "अनाम",
    "volunteer.unknown": "अज्ञात स्वयंसेवक",

    // Statuses
    "status.completed": "पूर्ण",
    "status.pending": "लंबित",
    "status.failed": "विफल",

    // Blockchain
    "blockchain.block": "ब्लॉक",

    // Filter
    "filter.allYears": "सभी वर्ष",
    "filter.allTypes": "सभी प्रकार",
    "filter.donations": "दान",
    "filter.volunteerApplications": "स्वयंसेवक आवेदन",
    "filter.volunteerHours": "स्वयंसेवक घंटे",
    "filter.fiatDonations": "फ़िएट दान",

    // Export
    "export.title": "योगदान डेटा निर्यात करें",
    "export.filename": "फ़ाइल नाम",
    "export.dateRange": "तिथि सीमा",
    "export.includePersonal": "वॉलेट पते शामिल करें",
    "export.willInclude": "निर्यात में शामिल होगा:",
    "export.walletAddresses": "वॉलेट पते (प्रेषक और प्राप्तकर्ता)",
    "export.volunteerDetails": "स्वयंसेवक योगदान विवरण (जब लागू हो)",
    "export.verificationHashes": "सत्यापन हैश (जब लागू हो)",
    "export.cancel": "रद्द करें",
    "export.download": "CSV निर्यात करें",

    // Skills
    "skills.endorsements": "कौशल और अनुमोदन",

    // Home
    "home.subtitle":
      "संसाधनों को उन कारणों से जोड़ना जिन्हें उनकी सबसे अधिक आवश्यकता है",
    "home.startDonating": "दान शुरू करें",

    // Modal - shared
    "modal.close": "मोडल बंद करें",
    "modal.closeAriaLabel": "बंद करें",

    // Modal - wallet connection
    "modal.wallet.title": "अपना वॉलेट कनेक्ट करें",
    "modal.wallet.description":
      "Give Protocol की सभी सुविधाओं को अनलॉक करने के लिए वॉलेट कनेक्ट करें",
    "modal.wallet.benefit1":
      "ब्लॉकचेन पर अपने दान को पारदर्शी रूप से ट्रैक करें",
    "modal.wallet.benefit2":
      "अपने योगदान के लिए पुरस्कार के रूप में GIVE टोकन प्राप्त करें",
    "modal.wallet.benefit3": "प्रोटोकॉल के लिए शासन निर्णयों में भाग लें",
    "modal.wallet.connecting": "कनेक्ट हो रहा है...",
    "modal.wallet.clickToConnect": "कनेक्ट करने के लिए क्लिक करें",
    "modal.wallet.noExtension": "कोई वॉलेट एक्सटेंशन नहीं मिला।",
    "modal.wallet.installMetaMask": "शुरू करने के लिए MetaMask इंस्टॉल करें",
    "modal.wallet.skip": "अभी छोड़ें",
    "modal.wallet.footerNote":
      "आप नेविगेशन बार से कभी भी अपना वॉलेट कनेक्ट कर सकते हैं",
    "modal.wallet.failedConnect": "वॉलेट कनेक्ट करने में विफल",

    // Modal - wallet link
    "modal.walletLink.title": "अपना वॉलेट लिंक करें",
    "modal.walletLink.description":
      "ऑन-चेन दान, टोकन पुरस्कार, और शासन के लिए अपने खाते से वॉलेट लिंक करें",
    "modal.walletLink.benefit1":
      "सत्यापित चैरिटी को सीधे ऑन-चेन क्रिप्टो दान करें",
    "modal.walletLink.benefit2Pre": "विकसित करें",
    "modal.walletLink.benefit2Post": "अपने योगदान के लिए क्रेडेंशियल",
    "modal.walletLink.benefit3":
      "ईमेल या वॉलेट से साइन इन करें \u2014 एक ही खाता",
    "modal.walletLink.buttonLinking": "लिंक हो रहा है\u2026",
    "modal.walletLink.buttonLink": "वॉलेट लिंक करें",
    "modal.walletLink.buttonConnectFirst": "पहले वॉलेट कनेक्ट करें",
    "modal.walletLink.footerNote":
      "आप सेटिंग्स से कभी भी अपना वॉलेट लिंक कर सकते हैं",
    "modal.walletLink.failedLink": "वॉलेट लिंक करने में विफल",

    // Modal - chain selection
    "modal.chain.title": "Give Protocol में आपका स्वागत है",
    "modal.chain.subtitle": "शुरू करने के लिए अपना पसंदीदा नेटवर्क चुनें",
    "modal.chain.footerNote": "आप मेनू से कभी भी नेटवर्क बदल सकते हैं",
    "modal.chain.connecting": "कनेक्ट हो रहा है...",
    "modal.chain.continue": "जारी रखें",
    "modal.chain.failedSelect": "नेटवर्क चुनने में विफल",

    // Modal - network selection (WalletModal step 1)
    "modal.network.title": "नेटवर्क चुनें",
    "modal.network.nextStep": "अगला कदम: वॉलेट कनेक्ट करें",
    "modal.network.learnMore": "नेटवर्क चयन के बारे में अधिक जानें",

    // Modal - wallet connect (WalletModal step 2)
    "modal.connect.title": "वॉलेट कनेक्ट करें",
    "modal.connect.backAria": "नेटवर्क चयन पर वापस जाएं",
    "modal.connect.noWallets":
      "{{chainType}} चेन के लिए कोई वॉलेट उपलब्ध नहीं है।",
    "modal.connect.tryDifferentChain":
      "कोई अन्य चेन प्रकार चुनने का प्रयास करें।",
    "modal.connect.viewOtherWallets": "अन्य समर्थित वॉलेट देखें",
    "modal.connect.termsAgreement": "कनेक्ट करके, आप हमारी",
    "modal.connect.termsLink": "सेवा की शर्तें",
    "modal.connect.termsPrivacyConnector": "और",
    "modal.connect.privacyLink": "गोपनीयता नीति",
    "modal.connect.chainTypeAria": "चेन प्रकार",
    "modal.connect.failedConnect": "कनेक्शन विफल",

    // Modal - donation
    "modal.donation.successTitle": "धन्यवाद!",
    "modal.donation.donationProcessedOneTime":
      "{{charityName}} को आपका {{amount}} का दान संसाधित कर दिया गया है।",
    "modal.donation.donationProcessedRecurring":
      "{{charityName}} को आपका {{amount}} का मासिक दान संसाधित कर दिया गया है।",
    "modal.donation.recurringNote":
      "जब तक आप रद्द नहीं करते, आपसे मासिक शुल्क लिया जाएगा।",
    "modal.donation.receiptNote": "आपके ईमेल पर एक रसीद भेजी गई है।",
    "modal.donation.done": "पूर्ण",
    "modal.donation.errorTitle": "कुछ गलत हो गया",
    "modal.donation.errorDefault":
      "एक अप्रत्याशित त्रुटि हुई। कृपया पुनः प्रयास करें।",
    "modal.donation.tryAgain": "पुनः प्रयास करें",
    "modal.donation.close": "बंद करें",
    "modal.donation.amountLabel": "दान राशि",
    "modal.donation.perMonth": "प्रति माह",
    "modal.donation.monthly": "मासिक",
    "modal.donation.oneTime": "एक बार",
    "modal.donation.loadingPaymentForm": "भुगतान फ़ॉर्म लोड हो रहा है...",
    "modal.donation.supportMonthly": "{{charityName}} को मासिक सहायता दें",
    "modal.donation.donateToCharity": "{{charityName}} को दान करें",

    // Modal - scheduled donation
    "modal.scheduledDonation.title":
      "{{charityName}} के लिए मासिक दान शेड्यूल करें",

    // Modal - withdrawal
    "modal.withdrawal.title": "निकासी अनुरोध",

    // Modal - validation response
    "modal.validation.rejectTitle": "मान्यता अनुरोध अस्वीकार करें",
    "modal.validation.reviewTitle": "मान्यता अनुरोध की समीक्षा करें",
    "modal.validation.volunteer": "स्वयंसेवक",
    "modal.validation.activityDetails": "गतिविधि विवरण",
    "modal.validation.date": "तिथि",
    "modal.validation.hour": "घंटा",
    "modal.validation.hours": "घंटे",
    "modal.validation.activityType": "गतिविधि प्रकार",
    "modal.validation.location": "स्थान",
    "modal.validation.description": "विवरण",
    "modal.validation.submitted": "प्रस्तुत किया गया:",
    "modal.validation.daysRemaining": "(मान्य करने के लिए {{count}} दिन शेष)",
    "modal.validation.appealNote":
      "यह पहले अस्वीकृत अनुरोध की अपील/पुनः प्रस्तुति है",
    "modal.validation.rejectPrompt":
      "कृपया इस मान्यता अनुरोध को अस्वीकार करने का कारण चुनें। स्वयंसेवक को सूचित किया जाएगा।",
    "modal.validation.reject": "अस्वीकार करें",
    "modal.validation.approve": "स्वीकृत करें",
    "modal.validation.processing": "प्रसंस्करण हो रहा है...",
    "modal.validation.back": "वापस",
    "modal.validation.confirmRejection": "अस्वीकृति की पुष्टि करें",
    "modal.validation.selectReasonError": "कृपया अस्वीकृति का कारण चुनें",

    // Toast
    "toast.dismiss": "सूचना खारिज करें",

    // Error boundary
    "error.somethingWrong": "कुछ गलत हो गया",
    "error.unexpectedError": "एक अप्रत्याशित त्रुटि हुई",
    "error.tryAgain": "पुनः प्रयास करें",
    "error.tooManyAttempts": "बहुत अधिक प्रयास",
    "error.goHome": "होमपेज पर जाएं",
    "error.details": "त्रुटि विवरण",

    // Validation - rejection reason select
    "validation.rejection.reasonLabel": "अस्वीकृति कारण",
    "validation.rejection.reasonPlaceholder": "कारण चुनें...",
    "validation.rejection.notesLabel": "अतिरिक्त टिप्पणियां",
    "validation.rejection.optional": "(वैकल्पिक)",
    "validation.rejection.notesPlaceholder":
      "अस्वीकृति के लिए अतिरिक्त संदर्भ प्रदान करें...",

    // Validation - batch actions
    "validation.batch.deselectAll": "सभी अचयनित करें",
    "validation.batch.selectAll": "सभी चयनित करें",
    "validation.batch.selected": "{{total}} में से {{selected}} चयनित",
    "validation.batch.clear": "साफ़ करें",
    "validation.batch.reject": "अस्वीकार करें ({{count}})",
    "validation.batch.approve": "स्वीकृत करें ({{count}})",

    // Dashboard - admin redirect (GIV-254)
    "dashboard.adminTitle": "एडमिन डैशबोर्ड",
    "dashboard.adminNote":
      "प्लेटफ़ॉर्म प्रबंधन के लिए कृपया एडमिन पैनल का उपयोग करें।",
    "dashboard.adminButton": "एडमिन पैनल पर जाएं",
    "dashboard.logVolunteerHours": "स्वयंसेवक घंटे दर्ज करें",
    "dashboard.hideVolunteerHours": "स्वयंसेवक घंटे छुपाएं",
    "dashboard.viewMonthlyDonations": "मासिक दान देखें",
    "dashboard.hideMonthlyDonations": "मासिक दान छुपाएं",
    "dashboard.walletSettings": "वॉलेट सेटिंग्स",
    "dashboard.overview": "अवलोकन",
    "dashboard.lastUpdated": "अंतिम अपडेट",
    "dashboard.refreshData": "डेटा रिफ़्रेश करें",
    "dashboard.searchPlaceholder": "परियोजनाएं, स्वयंसेवक खोजें (Cmd+K)",
    "dashboard.search": "खोजें",

    // Settings - account section (GIV-254)
    "settings.manageDescription": "अपना खाता और प्राथमिकताएं प्रबंधित करें",
    "settings.account": "खाता",
    "settings.email": "ईमेल",
    "settings.displayName": "प्रदर्शन नाम",
    "settings.authMethod": "प्रमाणीकरण विधि",
    "settings.role": "भूमिका",

    // Common additional (GIV-254)
    "common.refresh": "रिफ़्रेश करें",
    "common.all": "सभी",
    "common.loading": "लोड हो रहा है...",
    "common.close": "बंद करें",
    "common.back": "वापस",

    // Cause (GIV-254)
    "cause.createCause": "कारण बनाएं",

    // Contribution Tracker (GIV-254)
    "tracker.title": "वैश्विक प्रभाव रैंकिंग",
    "tracker.subtitle": "हमारे समुदाय के सामूहिक प्रभाव को ट्रैक और सराहें",
    "tracker.searchPlaceholder": "योगदानकर्ता खोजें...",
    "tracker.exportCSV": "CSV निर्यात करें",
    "tracker.exportPDF": "PDF निर्यात करें",
    "tracker.hideContributions": "मेरे योगदान रैंकिंग से छुपाएं",
    "tracker.yourAlias": "आपका उपनाम:",
    "tracker.changeAlias": "बदलें",
    "tracker.setWalletAlias": "वॉलेट उपनाम सेट करें",
    "tracker.aliasTitle": "वॉलेट उपनाम सेट करें",
    "tracker.aliasDescription":
      "आपका उपनाम योगदान ट्रैकर पर आपके वॉलेट पते के बजाय प्रदर्शित किया जाएगा।",
    "tracker.aliasLabel": "उपनाम",
    "tracker.aliasPlaceholder": "अपना पसंदीदा उपनाम दर्ज करें",
    "tracker.saveAlias": "उपनाम सहेजें",
    "tracker.donationRankings": "दान रैंकिंग",
    "tracker.volunteerRankings": "स्वयंसेवक रैंकिंग",
    "tracker.exportComplete": "निर्यात पूर्ण",
    "tracker.exportDonationCSV":
      "दान लीडरबोर्ड CSV के रूप में निर्यात किया गया",
    "tracker.exportVolunteerCSV":
      "स्वयंसेवक लीडरबोर्ड CSV के रूप में निर्यात किया गया",
    "tracker.exportPDFSuccess": "लीडरबोर्ड PDF के रूप में निर्यात किया गया",
    "tracker.exportFailed": "निर्यात विफल",
    "tracker.exportNoData": "निर्यात के लिए कोई डेटा उपलब्ध नहीं",
    "tracker.exportError": "डेटा निर्यात करते समय एक त्रुटि हुई",
    "tracker.walletNotConnected": "वॉलेट कनेक्ट नहीं है",
    "tracker.connectWalletForAlias":
      "उपनाम सेट करने के लिए कृपया अपना वॉलेट कनेक्ट करें",
    "tracker.invalidAlias": "अमान्य उपनाम",
    "tracker.enterValidAlias": "कृपया एक मान्य उपनाम दर्ज करें",

    // Charity Portal (GIV-254)
    "charity.portal.deleteTitle": "{{type}} हटाएं?",
    "charity.portal.deleteDescription":
      "यह क्रिया पूर्ववत नहीं की जा सकती। {{type}} स्थायी रूप से हटा दिया जाएगा।",
    "charity.portal.walletNotConfigured":
      "प्राप्त करने वाला वॉलेट कॉन्फ़िगर नहीं है।",
    "charity.portal.walletDonationNote":
      "ऑन-चेन दान प्राप्त करने के लिए वॉलेट कनेक्ट करें।",
    "charity.portal.setupWallet": "वॉलेट सेट अप करें",

    // Charity dashboard onboarding & verification
    "charity.onboarding.ariaLabel": "ऑनबोर्डिंग चेकलिस्ट",
    "charity.onboarding.title": "शुरू करें",
    "charity.onboarding.progress": "{{total}} में से {{completed}} चरण पूरे",
    "charity.onboarding.optional": "वैकल्पिक",
    "charity.onboarding.allComplete":
      "सभी चरण पूरे हो गए! आप इस चेकलिस्ट को बंद कर सकते हैं।",
    "charity.onboarding.expand": "चेकलिस्ट खोलें",
    "charity.onboarding.collapse": "चेकलिस्ट छोटी करें",
    "charity.onboarding.dismiss": "ऑनबोर्डिंग चेकलिस्ट बंद करें",
    "charity.onboarding.check": "{{label}} पर निशान लगाएँ",
    "charity.onboarding.uncheck": "{{label}} से निशान हटाएँ",
    "charity.onboarding.stepDone": "{{label}} (पूरा हुआ)",
    "charity.onboarding.stepAuto": "{{label}} (अपने-आप पूरा होता है)",
    "charity.onboarding.goToOrganization": "संगठन पर जाएँ",
    "charity.onboarding.setupWallet": "वॉलेट सेट अप करें",
    "charity.onboarding.item.completeProfile.label":
      "संगठन की प्रोफ़ाइल पूरी करें",
    "charity.onboarding.item.completeProfile.description":
      "अपने संगठन का नाम, विवरण, पता और संपर्क जानकारी जोड़ें।",
    "charity.onboarding.item.uploadLogo.label": "लोगो या बैनर छवि अपलोड करें",
    "charity.onboarding.item.uploadLogo.description":
      "दानदाताओं को आपकी चैरिटी पहचानने में मदद के लिए लोगो या बैनर जोड़ें।",
    "charity.onboarding.item.connectWallet.label": "प्राप्ति वॉलेट सेट अप करें",
    "charity.onboarding.item.connectWallet.description":
      "दान प्राप्त करने के लिए मल्टीसिग Safe, संस्थागत कस्टडी या सिंगल-साइनर वॉलेट चुनें। संदेश पर हस्ताक्षर करके नियंत्रण साबित करें।",
    "charity.onboarding.item.bankDetails.label":
      "फ़िएट ऑफ़-रैंप के लिए बैंक विवरण सेट अप करें",
    "charity.onboarding.item.bankDetails.description":
      "यदि आप कार्ड से दान स्वीकार करना चाहते हैं तो बैंक जानकारी कॉन्फ़िगर करें।",
    "charity.onboarding.item.acceptTerms.label":
      "सेवा की शर्तें पढ़ें और स्वीकार करें",
    "charity.onboarding.item.acceptTerms.description":
      "चैरिटी के लिए Give Protocol के नियम और शर्तें पढ़ें और पुष्टि करें।",
    "charity.verification.pendingTitle": "आवेदन की समीक्षा जारी है",
    "charity.verification.pendingBody":
      "हमारी टीम आपकी चैरिटी के आवेदन की समीक्षा कर रही है। इसमें आमतौर पर 3–5 कार्य दिवस लगते हैं। निर्णय होने पर हम आपको ईमेल करेंगे।",
    "charity.verification.rejectedTitle": "आवेदन स्वीकृत नहीं हुआ",
    "charity.verification.reason": "कारण: {{notes}}",
    "charity.verification.rejectedDefault":
      "आपका आवेदन इस समय स्वीकृत नहीं किया गया।",
    "charity.verification.contactSupport": "सहायता से संपर्क करें",
    "charity.verification.suspendedTitle": "खाता निलंबित",
    "charity.verification.suspendedDefault":
      "आपकी चैरिटी का खाता निलंबित कर दिया गया है।",
    "charity.verification.appealSuspension": "निलंबन के विरुद्ध अपील करें",
    "charity.verification.verifiedTitle": "चैरिटी सत्यापित",
    "charity.verification.verifiedBody":
      "आपका संगठन सत्यापित है और दानदाता अब आपके अभियानों का समर्थन कर सकते हैं।",
    "charity.portal.receivingWallet": "प्राप्ति वॉलेट: {{address}}",
    "charity.portal.loadError":
      "चैरिटी डेटा लोड नहीं हो सका। कृपया पुनः प्रयास करें।",

    // Timestamps (GIV-254)
    "timestamp.justNow": "अभी अभी",
    "timestamp.oneMinuteAgo": "1 मिनट पहले",
    "timestamp.minutesAgo": "{{count}} मिनट पहले",

    // Common additions (GIV-256)
    "common.previous": "पिछला",
    "common.next": "अगला",
    "common.pageOfTotal": "पृष्ठ {{page}} / {{total}}",
    "common.retry": "पुनः प्रयास करें",
    "common.processing": "प्रसंस्करण हो रहा है...",
    "common.saving": "सहेजा जा रहा है...",
    "common.donate": "दान करें",
    "common.active": "सक्रिय",

    // Portfolio Funds - public page (GIV-256)
    "portfolio.donationType": "दान प्रकार",
    "portfolio.devNative": "DEV (नेटिव)",
    "portfolio.testToken": "TEST टोकन",
    "portfolio.donationAmount": "दान राशि:",
    "portfolio.platformFee": "प्लेटफ़ॉर्म शुल्क ({{percentage}}%):",
    "portfolio.toCharities": "चैरिटी को:",
    "portfolio.eachCharityReceives": "प्रत्येक चैरिटी को प्राप्त होगा:",
    "portfolio.donateToFund": "{{name}} को दान करें",
    "portfolio.equalDistribution": "समान वितरण",
    "portfolio.equalDistributionNote":
      "आपका दान {{count}} सत्यापित चैरिटी के बीच समान रूप से विभाजित किया जाएगा।",
    "portfolio.eachCharityPercentage":
      "प्रत्येक चैरिटी को दान का {{percentage}}% प्राप्त होगा",
    "portfolio.verifiedCharities": "{{count}} सत्यापित चैरिटी",
    "portfolio.donateToFundButton": "फंड में दान करें",
    "portfolio.noFundsAvailable": "कोई पोर्टफ़ोलियो फंड उपलब्ध नहीं",
    "portfolio.checkBackLater": "नए वित्तपोषण अवसरों के लिए बाद में पुनः देखें",
    "portfolio.amountLabel": "राशि ({{currency}})",
    "portfolio.invalidAmount": "कृपया एक मान्य राशि दर्ज करें",
    "portfolio.donationSuccess": "दान सफल!",
    "portfolio.donationFailed": "दान विफल। कृपया पुनः प्रयास करें।",

    // Admin - Activity event type labels (GIV-256)
    "admin.activity.donation": "दान",
    "admin.activity.registration": "पंजीकरण",
    "admin.activity.verification": "सत्यापन",
    "admin.activity.volunteerHours": "स्वयंसेवक घंटे",
    "admin.activity.default": "गतिविधि",

    // Admin - Dashboard page (GIV-256)
    "admin.dashboard.title": "एडमिन डैशबोर्ड",
    "admin.dashboard.alerts": "अलर्ट",
    "admin.dashboard.alertsPending": "{{count}} लंबित",
    "admin.dashboard.alertsView": "देखें",
    "admin.dashboard.recentActivity": "हालिया गतिविधि",
    "admin.dashboard.noRecentActivity": "कोई हालिया गतिविधि नहीं।",
    "admin.dashboard.quickActions": "त्वरित कार्य",
    "admin.dashboard.errorTitle": "डैशबोर्ड लोड करने में त्रुटि",
    "admin.stats.last7d": "पिछले 7 दिन",
    "admin.stats.last30d": "पिछले 30 दिन",
    "admin.stats.totalDonors": "कुल दाता",
    "admin.stats.newRegistrations": "नए पंजीकरण",
    "admin.stats.charities": "चैरिटी",
    "admin.stats.pendingVerification": "सत्यापन लंबित",
    "admin.stats.verifiedCharities": "सत्यापित चैरिटी",
    "admin.stats.activeVolunteers": "सक्रिय स्वयंसेवक",
    "admin.stats.totalDonationVolume": "कुल दान मात्रा",
    "admin.stats.cryptoVolume": "क्रिप्टो मात्रा",
    "admin.stats.fiatVolume": "फ़िएट मात्रा",
    "admin.stats.donations": "दान",

    // Admin - Quick Actions (GIV-256)
    "admin.actions.viewReports": "रिपोर्ट देखें",
    "admin.actions.viewReportsDesc": "विस्तृत विश्लेषण तैयार करें",
    "admin.actions.manageCharities": "चैरिटी प्रबंधित करें",
    "admin.actions.manageCharitiesDesc": "संगठनों की समीक्षा और स्वीकृति करें",
    "admin.actions.systemSettings": "सिस्टम सेटिंग्स",
    "admin.actions.systemSettingsDesc": "प्लेटफ़ॉर्म पैरामीटर कॉन्फ़िगर करें",
    "admin.actions.manageImpactMetrics": "प्रभाव मेट्रिक्स प्रबंधित करें",
    "admin.actions.manageImpactMetricsDesc":
      "प्रभाव कैलकुलेटर डेटा कॉन्फ़िगर करें",
    "admin.actions.donationMonitoring": "दान निगरानी",
    "admin.actions.donationMonitoringDesc":
      "दान की निगरानी, फ़्लैग, और रिपोर्ट करें",
    "admin.actions.contentModeration": "सामग्री मॉडरेशन",
    "admin.actions.contentModerationDesc":
      "अवसरों और कारणों को छुपाएं, फ़्लैग करें, और समीक्षा करें",
    "admin.actions.portfolioFunds": "पोर्टफ़ोलियो फंड",
    "admin.actions.portfolioFundsDesc":
      "क्यूरेटेड दान पोर्टफ़ोलियो बनाएं और प्रबंधित करें",
    "admin.actions.charityRequests": "चैरिटी अनुरोध",
    "admin.actions.charityRequestsDesc":
      "दावा नहीं की गई चैरिटी के लिए दाता अनुरोधों की समीक्षा करें",

    // Admin - Portfolio Funds management page (GIV-256)
    "admin.portfolio.title": "पोर्टफ़ोलियो फंड",
    "admin.portfolio.subtitle":
      "क्यूरेटेड दान पोर्टफ़ोलियो बनाएं और प्रबंधित करें",
    "admin.portfolio.newFund": "नया फंड",
    "admin.portfolio.editFund": "फंड संपादित करें",
    "admin.portfolio.createNewFund": "नया फंड बनाएं",
    "admin.portfolio.fundName": "फंड का नाम",
    "admin.portfolio.fundNamePlaceholder": "जैसे पर्यावरण प्रभाव फंड",
    "admin.portfolio.description": "विवरण",
    "admin.portfolio.descriptionPlaceholder":
      "फंड के उद्देश्य और प्रभाव फ़ोकस का वर्णन करें...",
    "admin.portfolio.category": "श्रेणी",
    "admin.portfolio.selectCategory": "श्रेणी चुनें",
    "admin.portfolio.imageUrl": "छवि URL",
    "admin.portfolio.imageUrlPlaceholder": "https://...",
    "admin.portfolio.selectCharities": "चैरिटी चुनें ({{count}} चयनित)",
    "admin.portfolio.noCharitiesFound": "कोई सत्यापित चैरिटी नहीं मिली",
    "admin.portfolio.saving": "सहेजा जा रहा है...",
    "admin.portfolio.createFund": "फंड बनाएं",
    "admin.portfolio.updateFund": "फंड अपडेट करें",
    "admin.portfolio.noFundsYet": "अभी कोई पोर्टफ़ोलियो फंड नहीं",
    "admin.portfolio.noFundsMessage":
      "बंडल दान के लिए चैरिटी को समूहित करने हेतु अपना पहला फंड बनाएं",
    "admin.portfolio.charity": "चैरिटी",
    "admin.portfolio.charities": "चैरिटी",
    "admin.portfolio.createdOn": "{{date}} को बनाया गया",
    "admin.portfolio.statusActive": "सक्रिय",
    "admin.portfolio.statusPaused": "रुका हुआ",
    "admin.portfolio.statusArchived": "संग्रहीत",
    "admin.portfolio.errorLoad": "डेटा लोड करने में विफल",
    "admin.portfolio.errorArchive": "फंड संग्रहित करने में विफल",
    "admin.portfolio.fundArchived": "फंड संग्रहित किया गया",
    "admin.portfolio.fundUpdated": "फंड अपडेट किया गया",
    "admin.portfolio.fundCreated": "फंड बनाया गया",
    "admin.portfolio.errorSave": "फंड सहेजने में विफल",

    // Admin - Charity Management page (GIV-256)
    "admin.charity.title": "चैरिटी प्रबंधन",
    "admin.charity.totalCount": "कुल {{count}}",
    "admin.charity.allStatuses": "सभी स्थितियां",
    "admin.charity.searchPlaceholder": "नाम से खोजें\u2026",
    "admin.charity.colName": "नाम",
    "admin.charity.colEin": "कर पहचान संख्या",
    "admin.charity.taxIdDisplay": "कर पहचान संख्या {{value}}",
    "admin.charity.searchByNameEin": "नाम या कर पहचान संख्या से खोजें…",
    "admin.charity.colCategory": "श्रेणी",
    "admin.charity.colStatus": "स्थिति",
    "admin.charity.colSigner": "संपर्क",
    "admin.charity.colJoined": "शामिल हुए",
    "admin.charity.colWallet": "वॉलेट",
    "admin.charity.colActions": "कार्य",
    "admin.charity.walletNotSet": "सेट नहीं",
    "admin.charity.approve": "स्वीकृत करें",
    "admin.charity.reject": "अस्वीकार करें",
    "admin.charity.suspend": "निलंबित करें",
    "admin.charity.reinstate": "बहाल करें",
    "admin.charity.statusPending": "लंबित",
    "admin.charity.statusVerified": "सत्यापित",
    "admin.charity.statusApproved": "स्वीकृत",
    "admin.charity.statusRejected": "अस्वीकृत",
    "admin.charity.statusSuspended": "निलंबित",
    "admin.charity.approveTitle": "चैरिटी स्वीकृत करें",
    "admin.charity.rejectTitle": "चैरिटी अस्वीकार करें",
    "admin.charity.suspendTitle": "चैरिटी निलंबित करें",
    "admin.charity.reinstateTitle": "चैरिटी बहाल करें",
    "admin.charity.confirmAction": "कार्य की पुष्टि करें",
    "admin.charity.reasonRequired": "कारण (आवश्यक)",
    "admin.charity.reasonOptional": "कारण (वैकल्पिक)",
    "admin.charity.saving": "सहेजा जा रहा है\u2026",
    "admin.charity.confirm": "पुष्टि करें",
    "admin.charity.noResults": "आपके फ़िल्टर से मेल खाती कोई चैरिटी नहीं मिली।",
    "admin.charity.unnamed": "अनाम संगठन",

    // Admin - Charity Requests page (GIV-256)
    "admin.charityRequests.title": "चैरिटी अनुरोध",
    "admin.charityRequests.subtitle":
      "दावा नहीं की गई चैरिटी के लिए दाता-प्रस्तुत अनुरोध, संगठन द्वारा समूहित। सबसे अधिक रुचि वाले संगठनों को संपर्क के लिए प्राथमिकता दी जानी चाहिए।",
    "admin.charityRequests.ein": "कर पहचान संख्या",
    "admin.charityRequests.requests": "अनुरोध",
    "admin.charityRequests.latestRequester": "नवीनतम अनुरोधकर्ता",
    "admin.charityRequests.latestRequest": "नवीनतम अनुरोध",
    "admin.charityRequests.firstRequest": "पहला अनुरोध",
    "admin.charityRequests.empty":
      "अभी तक कोई चैरिटी अनुरोध प्रस्तुत नहीं किया गया है।",
    "admin.charityRequests.errorTitle": "चैरिटी अनुरोध लोड करने में त्रुटि",
    "admin.charityRequests.showing":
      "{{total}} अद्वितीय संगठनों में से {{shown}} दिखाए जा रहे हैं।",

    // Admin - Volunteer Validation page (GIV-256)
    "admin.validation.title": "स्वयंसेवक मान्यता निरीक्षण",
    "admin.validation.totalCount": "कुल {{count}} अनुरोध",
    "admin.validation.pipelineStats": "पाइपलाइन सांख्यिकी",
    "admin.validation.noStats": "कोई सांख्यिकी उपलब्ध नहीं।",
    "admin.validation.pending": "लंबित",
    "admin.validation.approved": "स्वीकृत",
    "admin.validation.rejected": "अस्वीकृत",
    "admin.validation.expired": "समाप्त",
    "admin.validation.avgResponseTime": "औसत प्रतिक्रिया समय:",
    "admin.validation.expirationRate": "समाप्ति दर:",
    "admin.validation.rejectionRate": "अस्वीकृति दर:",
    "admin.validation.searchPlaceholder": "स्वयंसेवक, संगठन खोजें\u2026",
    "admin.validation.requestsTab": "मान्यता अनुरोध",
    "admin.validation.patternsTab": "संदिग्ध पैटर्न",
    "admin.validation.colVolunteer": "स्वयंसेवक",
    "admin.validation.colOrganisation": "संगठन",
    "admin.validation.colHours": "घंटे",
    "admin.validation.colActivityDate": "गतिविधि तिथि",
    "admin.validation.colHrsPerWeek": "घंटे/सप्ताह",
    "admin.validation.colTotalRequests": "कुल अनुरोध",
    "admin.validation.override": "ओवरराइड",
    "admin.validation.noPatterns": "कोई संदिग्ध पैटर्न नहीं पाया गया।",
    "admin.validation.noRequests": "कोई मान्यता अनुरोध नहीं मिला।",
    "admin.validation.patternsDescription":
      "रोलिंग 7-दिन की अवधि में कॉन्फ़िगर की गई सीमा से अधिक घंटे रिपोर्ट करने वाले स्वयंसेवक चिह्नित किए गए हैं। ये पैटर्न स्व-रिपोर्टेड घंटों की प्रणाली के दुरुपयोग का संकेत दे सकते हैं।",
    "admin.validation.overrideTitle": "मान्यता अनुरोध ओवरराइड करें",
    "admin.validation.newStatus": "नई स्थिति",
    "admin.validation.reasonRequired": "कारण (आवश्यक)",
    "admin.validation.reasonPlaceholder":
      "इस अनुरोध को ओवरराइड करने का कारण बताएं\u2026",
    "admin.validation.saving": "सहेजा जा रहा है\u2026",
    "admin.validation.confirmOverride": "ओवरराइड की पुष्टि करें",
    "admin.validation.allStatuses": "सभी स्थितियां",
    "admin.validation.colStatus": "स्थिति",
    "admin.validation.colCreated": "बनाया गया",

    // GIV-266: Delta translations (354 keys)
    "home.hero.title": "पारदर्शी दान",
    "home.hero.titleAccent": "सतत प्रभाव",
    "home.hero.description":
      "डिजिटल युग के लिए पूर्णतः पारदर्शी परोपकार। प्रभाव के लिए निर्मित, सत्यापन योग्य तकनीक द्वारा समर्थित। प्रत्येक योगदान दाता से गंतव्य तक ट्रेस करने योग्य।",
    "home.hero.visionTitle": "हमारा विज़न",
    "home.hero.visionText":
      "Give Protocol उच्च-विश्वसनीयता वाले दान के भविष्य का निर्माण कर रहा है। हम वैश्विक पूंजी और स्थानीय प्रभाव के बीच की खाई को पाटने के लिए उन्नत तकनीकी अवसंरचना का उपयोग करते हैं। पारंपरिक दान विधियों के साथ सहज डिजिटल-एसेट समर्थन को एकीकृत करके, हम ऐसे सशक्त वित्तपोषण पारिस्थितिकी तंत्र बना रहे हैं जो एक बार के दान को विश्व के सबसे महत्वपूर्ण उद्देश्यों के लिए निरंतर सहायता के इंजन में बदल देते हैं।",
    "home.comingSoon": "शीघ्र उपलब्ध",
    "home.readDocs": "दस्तावेज़ पढ़ें",
    "home.features.sectionTitle": "पारदर्शी परोपकार का आपका प्रवेश द्वार",
    "home.features.sectionSubtitle":
      "सहज दान के लिए मल्टीचेन अवसंरचना — क्रिप्टो या फ़िएट — पूर्ण पारदर्शिता के साथ",
    "home.features.highEfficiency.title": "उच्च-दक्षता दान",
    "home.features.highEfficiency.description":
      "सत्यापित संगठनों को बिना किसी अस्पष्टता के सीधे योगदान करें। हमारा स्वचालित लेजर वास्तविक समय सत्यापन प्रदान करता है, यह सुनिश्चित करते हुए कि आपका सहयोग ठीक वहीं पहुँचे जहाँ इसकी सबसे अधिक आवश्यकता है।",
    "home.features.equityFunds.title": "चैरिटेबल इक्विटी फ़ंड",
    "home.features.equityFunds.description":
      "स्मार्ट-प्रबंधित इक्विटी फ़ंड में योगदान करके एकबारगी दान से आगे बढ़ें। हम आपकी मूल राशि को निरंतर वित्तपोषण की धारा में बदलने के लिए परिष्कृत, कम-जोखिम वाली डिजिटल रणनीतियों का उपयोग करते हैं, जो आने वाली पीढ़ियों तक परोपकारी मिशनों को बनाए रखती हैं।",
    "home.features.impactFunds.title": "इम्पैक्ट फ़ंड",
    "home.features.impactFunds.description":
      "विशिष्ट उद्देश्यों के लिए संसाधन एकत्र करें। पर्यावरण, शिक्षा, गरीबी उन्मूलन - सामूहिक कार्रवाई से आपका दान बढ़ता है।",
    "home.features.verifiedOrgs.title": "सत्यापित संगठन",
    "home.features.verifiedOrgs.description":
      "किसी भी पंजीकृत संगठन को खोजें, या सत्यापित बैज की तलाश करें। जो संगठन हमारी जाँच प्रक्रिया में शामिल होते हैं, वे ऑन-चेन सत्यापन प्राप्त करते हैं जिस पर दाता विश्वास कर सकते हैं।",
    "home.features.blockchainVerified.title": "ब्लॉकचेन सत्यापित",
    "home.features.blockchainVerified.description":
      "सोल-बाउंड टोकन स्वयंसेवक योगदानों को मान्यता देते हैं। कौशल, घंटे और प्रभाव - सब कुछ स्थायी रूप से ऑन-चेन दर्ज।",
    "home.features.bridgingModes.title": "दान के तरीकों को जोड़ना",
    "home.features.bridgingModes.description":
      "चाहे आप USD में दे रहे हों या डिजिटल एसेट में, हमारा मल्टी-नेटवर्क आर्किटेक्चर सुनिश्चित करता है कि आपका योगदान आधुनिक दुनिया की गति से आगे बढ़े।",
    "home.roles.title": "दुनिया बदलने वाले हर व्यक्ति के लिए निर्मित",
    "home.roles.donors.title": "दाताओं के लिए",
    "home.roles.donors.item1": "क्रिप्टो या फ़िएट में दान करें — आपकी पसंद",
    "home.roles.donors.item2": "शासन में भागीदारी",
    "home.roles.donors.item3": "ऑन-चेन प्रतिष्ठा निर्माण",
    "home.roles.nonprofits.title": "गैर-लाभकारी संगठनों के लिए",
    "home.roles.nonprofits.item1": "नए दाता वर्गों तक पहुँच",
    "home.roles.nonprofits.item2": "CEF के माध्यम से सतत वित्तपोषण",
    "home.roles.nonprofits.item3": "उन्नत पारदर्शिता रिपोर्टिंग",
    "home.roles.volunteers.title": "स्वयंसेवकों के लिए",
    "home.roles.volunteers.item1": "सत्यापन योग्य योगदान रिकॉर्ड",
    "home.roles.volunteers.item2": "पोर्टेबल कौशल प्रमाण-पत्र (SBT)",
    "home.roles.volunteers.item3": "उपलब्धि बैज और मान्यता",
    "home.impact.title": "नियोजित इम्पैक्ट फ़ंड",
    "home.impact.environmental.title": "पर्यावरण प्रभाव फ़ंड",
    "home.impact.environmental.description":
      "पुनर्वनीकरण, समुद्र सफाई और नवीकरणीय ऊर्जा पहल का समर्थन। सत्यापित पर्यावरण संगठनों को निर्देशित सामूहिक दान जो मापने योग्य प्रभाव डाल रहे हैं।",
    "home.impact.education.title": "शिक्षा अवसर फ़ंड",
    "home.impact.education.description":
      "छात्रवृत्ति, डिजिटल शिक्षण उपकरण और शिक्षक प्रशिक्षण प्रदान करना। वंचित समुदायों में शैक्षिक पहल का समर्थन करने के लिए सामूहिक वित्तपोषण।",
    "home.cta.title": "दान को बदलने के लिए तैयार हैं?",
    "home.cta.subtitle":
      "पारदर्शी, ब्लॉकचेन-संचालित परोपकार का अनुभव करने वाले पहले लोगों में शामिल हों। परोपकारी दान के बेहतर भविष्य का निर्माण कर रहे हमारे समुदाय से जुड़ें।",
    "home.cta.explore": "उद्देश्य देखें",
    "home.nav.features": "विशेषताएँ",
    "home.nav.impact": "प्रभाव",
    "home.nav.charities": "संस्थाएँ",
    "home.nav.volunteer": "स्वयंसेवा",
    "home.footer.brand.tagline":
      "ब्लॉकचेन पारदर्शिता और सतत वित्तपोषण के माध्यम से परोपकार का रूपांतरण।",
    "home.footer.product.title": "उत्पाद",
    "home.footer.product.impactFunds": "इम्पैक्ट फ़ंड",
    "home.footer.product.charities": "संस्थाओं के लिए",
    "home.footer.product.volunteers": "स्वयंसेवकों के लिए",
    "home.footer.resources.title": "संसाधन",
    "home.footer.resources.whitepaper": "व्हाइटपेपर (शीघ्र उपलब्ध)",
    "home.footer.resources.blog": "ब्लॉग (शीघ्र उपलब्ध)",
    "home.footer.resources.community": "समुदाय (शीघ्र उपलब्ध)",
    "home.footer.connect.title": "संपर्क करें",
    "home.footer.connect.contact": "संपर्क (शीघ्र उपलब्ध)",
    "home.footer.copyright":
      "Give Protocol. डिज़ाइन से मल्टीचेन। Give Protocol स्वयंसेवकों द्वारा संचालित।",
    "auth.signin.welcomeBack": "पुनः स्वागत है",
    "auth.signin.subtitle": "अपने Give Protocol खाते में साइन इन करें",
    "auth.signin.emailPlaceholder": "ईमेल",
    "auth.signin.passwordPlaceholder": "पासवर्ड",
    "auth.signin.submitting": "साइन इन हो रहा है…",
    "auth.signin.withPasskey": "पासकी से साइन इन करें",
    "auth.signin.withGoogle": "Google से जारी रखें",
    "auth.signin.or": "या",
    "auth.signin.newToProtocol": "Give Protocol पर नए हैं?",
    "auth.signin.createAccount": "खाता बनाएँ →",
    "auth.signin.forgotPasswordLink": "पासवर्ड भूल गए? →",
    "auth.signin.sslEncrypted": "TLS एन्क्रिप्टेड",
    "auth.signin.modeToggleLabel": "साइन-इन विधि",
    "auth.signin.terms": "शर्तें",
    "auth.signin.privacy": "गोपनीयता",
    "auth.panel.headline": "स्मार्ट दान, पारदर्शी प्रभाव।",
    "auth.panel.subheadline":
      "एक खाता। कार्ड या क्रिप्टो से दान करें। हर रुपये को ऑन-चेन ट्रैक करें।",
    "auth.panel.statusLabel": "प्रोटोकॉल स्थिति · जेनेसिस चरण",
    "auth.panel.statusDesc": "पारदर्शी दान की नींव का निर्माण",
    "auth.panel.runsOn": "इस पर चलता है",
    "auth.wallet.connect": "वॉलेट कनेक्ट करें",
    "auth.wallet.connecting": "वॉलेट कनेक्ट हो रहा है…",
    "auth.wallet.signing": "संदेश पर हस्ताक्षर हो रहा है…",
    "auth.wallet.verifying": "सत्यापन हो रहा है…",
    "auth.wallet.openingSession": "सत्र खोला जा रहा है…",
    "auth.validation.emailRequired": "कृपया पहले अपना ईमेल पता दर्ज करें",
    "auth.validation.invalidEmail": "कृपया एक मान्य ईमेल पता दर्ज करें",
    "auth.validation.passwordTooShort":
      "पासवर्ड कम से कम 8 अक्षरों का होना चाहिए",
    "auth.validation.passwordMismatch": "पासवर्ड मेल नहीं खाते",
    "auth.login.welcomeHeading": "Give Protocol में आपका स्वागत है",
    "auth.login.signInOrConnect": "साइन इन करें या कनेक्ट करें",
    "auth.login.skipToContent": "लॉगिन सामग्री पर जाएँ",
    "auth.login.donorTitle": "दाता साइन इन",
    "auth.login.donorSubtitle":
      "अपने दान डैशबोर्ड तक पहुँचने के लिए साइन इन करें",
    "auth.login.charityTitle": "गैर-लाभकारी पोर्टल",
    "auth.login.charitySubtitle":
      "अपने संगठन की प्रोफ़ाइल और दान प्रबंधित करें",
    "auth.login.back": "← वापस",
    "auth.login.continueDonor": "दाता के रूप में जारी रखें",
    "auth.login.connecting": "कनेक्ट हो रहा है…",
    "auth.login.connectWalletSignIn": "वॉलेट कनेक्ट करें और साइन इन करें",
    "auth.login.newToPlatform": "Give Protocol पर नए हैं?",
    "auth.login.newDonorSignUp": "नया दाता पंजीकरण",
    "auth.login.manageNonprofit":
      "मैं एक गैर-लाभकारी प्रोफ़ाइल प्रबंधित करता/करती हूँ",
    "auth.login.nonprofitTrayTitle": "Give Protocol पर नए हैं?",
    "auth.login.createNonprofitAccount": "गैर-लाभकारी खाता बनाएँ",
    "auth.login.registerOrg": "अपने संगठन को Give Protocol पर पंजीकृत करें",
    "auth.login.needHelp": "सहायता चाहिए?",
    "auth.login.forgotUsernameBtn": "उपयोगकर्ता नाम भूल गए?",
    "auth.login.forgotPasswordBtn": "पासवर्ड भूल गए?",
    "auth.donorLogin.mismatch":
      "दाता खाता नहीं मिला। यह ईमेल एक संस्था खाते के रूप में पंजीकृत है। कृपया संस्था लॉगिन का उपयोग करें।",
    "auth.donorLogin.signingIn": "साइन इन हो रहा है…",
    "auth.donorLogin.redirecting": "{{count}} में रीडायरेक्ट हो रहा है...",
    "auth.donorReg.pleaseWait": "कृपया प्रतीक्षा करें…",
    "auth.donorReg.signUpPasskey": "पासकी से साइन अप करें",
    "auth.donorReg.withGoogle": "Google से जारी रखें",
    "auth.donorReg.connectWallet": "वॉलेट कनेक्ट करें",
    "auth.donorReg.orSetPassword": "या पासवर्ड सेट करें",
    "auth.donorReg.creating": "खाता बनाया जा रहा है...",
    "auth.donorReg.createAccount": "दाता खाता बनाएँ",
    "auth.donorReg.privacyNotice": "खाता बनाकर, आप हमारी",
    "auth.donorReg.termsLink": "सेवा की शर्तें",
    "auth.donorReg.privacyAnd": "से सहमत होते हैं और हमारी",
    "auth.donorReg.privacyLink": "गोपनीयता नीति",
    "auth.charityLogin.mismatch":
      "यह ईमेल एक दाता खाते के रूप में पंजीकृत है। कृपया दाता पोर्टल पर साइन इन करें।",
    "auth.charityLogin.signingIn": "साइन इन हो रहा है...",
    "auth.charityLogin.or": "या",
    "auth.charityLogin.connecting": "कनेक्ट हो रहा है...",
    "auth.charityLogin.connectWallet": "वॉलेट कनेक्ट करें",
    "auth.forgot.resetPassword": "पासवर्ड रीसेट करें",
    "auth.forgot.forgotUsername": "उपयोगकर्ता नाम भूल गए",
    "auth.forgot.passwordDesc":
      "अपना ईमेल पता दर्ज करें और हम आपको पासवर्ड रीसेट लिंक भेजेंगे।",
    "auth.forgot.usernameDesc":
      "अपना ईमेल पता दर्ज करें और हम आपको आपका उपयोगकर्ता नाम भेजेंगे।",
    "auth.forgot.passwordSuccess": "पासवर्ड रीसेट निर्देश आपके ईमेल पर भेजे गए",
    "auth.forgot.usernameSuccess":
      "उपयोगकर्ता नाम अनुस्मारक आपके ईमेल पर भेजा गया",
    "auth.forgot.checkEmail": "अपना ईमेल जाँचें",
    "auth.forgot.backToSignIn": "साइन इन पर वापस जाएँ",
    "auth.forgot.emailPlaceholder": "अपना ईमेल पता दर्ज करें",
    "auth.forgot.genericError": "एक त्रुटि हुई। कृपया पुनः प्रयास करें।",
    "auth.forgot.sending": "भेजा जा रहा है...",
    "auth.forgot.sendResetLink": "रीसेट लिंक भेजें",
    "auth.forgot.sendUsername": "उपयोगकर्ता नाम भेजें",

    // Reset password (set new password page) — pending translation (GIV-367)
    "auth.resetPassword.title": "Set New Password",
    "auth.resetPassword.subtitle": "Choose a strong password for your account.",
    "auth.resetPassword.newPassword": "New Password",
    "auth.resetPassword.confirmPassword": "Confirm New Password",
    "auth.resetPassword.submit": "Update Password",
    "auth.resetPassword.updating": "Updating\u2026",
    "auth.resetPassword.mismatch": "Passwords do not match.",
    "auth.resetPassword.success": "Password updated successfully!",
    "auth.resetPassword.successSubtitle":
      "You can now sign in with your new password.",
    "auth.resetPassword.backToSignIn": "Back to Sign In",
    "auth.resetPassword.invalidLink":
      "This password reset link is invalid or has expired.",
    "auth.resetPassword.requestNew": "Request a new reset link",
    "auth.resetPassword.validating": "Validating reset link\u2026",
    "auth.orgSearch.orgNameLabel": "संगठन का नाम",
    "auth.orgSearch.searchPlaceholder": "संगठन के नाम से खोजें...",
    "auth.orgSearch.countryLabel": "देश",
    "auth.orgSearch.allCountries": "सभी देश",
    "auth.orgSearch.searchPrompt":
      "अपने संगठन को खोजने और उस पर दावा करने के लिए हमारे डेटाबेस में खोजें।",
    "auth.orgSearch.noResults": "कोई संगठन नहीं मिला।",
    "auth.orgSearch.loadMore": "और परिणाम लोड करें",
    "auth.orgSearch.cantFind": "अपना संगठन नहीं मिल रहा?",
    "auth.orgSearch.registerManually": "मैन्युअल रूप से पंजीकरण करें",
    "charity.claim.orgDetails": "संगठन विवरण (रजिस्ट्री से)",
    "charity.claim.orgNameLabel": "नाम",
    "charity.claim.einLabel": "कर पहचान संख्या",
    "charity.claim.locationLabel": "स्थान",
    "charity.claim.contactInfo": "संपर्क जानकारी",
    "charity.claim.contactName": "संपर्क नाम",
    "charity.claim.contactEmail": "संपर्क ईमेल",
    "charity.claim.accountSecurity": "खाता सुरक्षा",
    "charity.claim.password": "पासवर्ड",
    "charity.claim.confirmPassword": "पासवर्ड की पुष्टि करें",
    "charity.claim.backToSearch": "खोज पर वापस जाएँ",
    "charity.claim.creating": "खाता बनाया जा रहा है...",
    "charity.claim.submit": "संगठन पर दावा करें",
    "charity.claim.validation.name": "नाम 2 से 100 अक्षरों के बीच होना चाहिए",
    "charity.claim.validation.email": "कृपया एक मान्य ईमेल पता दर्ज करें",
    "charity.claim.validation.password":
      "पासवर्ड कम से कम 8 अक्षरों का होना चाहिए",
    "charity.claim.validation.confirmPassword": "पासवर्ड मेल नहीं खाते",
    "charity.claim.validation.fix": "कृपया सत्यापन त्रुटियों को ठीक करें",
    "charity.claim.useAsPublicEmail":
      "मेरे ईमेल को संगठन के सार्वजनिक संपर्क ईमेल के रूप में उपयोग करें",
    "charity.claim.publicContactEmail": "संगठन का सार्वजनिक संपर्क ईमेल",
    "charity.claim.privacyNotice":
      "आपका व्यक्तिगत हस्ताक्षरकर्ता ईमेल/फोन केवल सत्यापन के लिए उपयोग किया जाता है और अन्य प्लेटफ़ॉर्म उपयोगकर्ताओं को दिखाई नहीं देता। सार्वजनिक संपर्क ईमेल आपके संगठन प्रोफ़ाइल पर दिखाया जाता है।",
    "charity.claim.secondContactTitle": "द्वितीय संपर्क",
    "charity.claim.secondContactName": "द्वितीय संपर्क का नाम",
    "charity.claim.secondContactEmail": "द्वितीय संपर्क ईमेल",
    "charity.claim.secondContactHint":
      "एक अन्य व्यक्ति, जिसे आपकी संस्था के वॉलेट या भुगतान विवरण बदलने पर सूचित किया जाएगा।",
    "charity.claim.validation.secondEmailDistinct":
      "द्वितीय संपर्क ईमेल प्राथमिक ईमेल से भिन्न होना चाहिए",
    "charity.claim.error.creation": "खाता निर्माण विफल",
    "charity.claim.error.generic": "खाता बनाने में विफल",
    "charity.vetting.orgDetails": "संगठन विवरण",
    "charity.vetting.orgName": "संगठन का नाम",
    "charity.vetting.description": "विवरण",
    "charity.vetting.taxId": "कर या पंजीकरण संख्या",
    "charity.vetting.countryLabel": "देश",
    "charity.vetting.selectCountry": "देश चुनें",
    "charity.vetting.address": "पता",
    "charity.vetting.streetAddress": "गली का पता",
    "charity.vetting.city": "शहर",
    "charity.vetting.state": "राज्य/प्रांत",
    "charity.vetting.postalCode": "पिन कोड",
    "charity.vetting.contactInfo": "संपर्क जानकारी",
    "charity.vetting.contactName": "संपर्क नाम",
    "charity.vetting.contactEmail": "संपर्क ईमेल",
    "charity.vetting.accountSecurity": "खाता सुरक्षा",
    "charity.vetting.password": "पासवर्ड",
    "charity.vetting.confirmPassword": "पासवर्ड की पुष्टि करें",
    "charity.vetting.submitting": "आवेदन सबमिट हो रहा है...",
    "charity.vetting.submit": "संस्था आवेदन सबमिट करें",
    "charity.vetting.validation.orgName":
      "संगठन का नाम 2 से 100 अक्षरों के बीच होना चाहिए",
    "charity.vetting.validation.contactName":
      "संपर्क नाम 2 से 100 अक्षरों के बीच होना चाहिए",
    "charity.vetting.validation.email": "कृपया एक मान्य ईमेल पता दर्ज करें",
    "charity.vetting.validation.password":
      "पासवर्ड कम से कम 8 अक्षरों का होना चाहिए",
    "charity.vetting.validation.confirmPassword": "पासवर्ड मेल नहीं खाते",
    "charity.vetting.validation.description": "विवरण आवश्यक है",
    "charity.vetting.validation.category": "श्रेणी आवश्यक है",
    "charity.vetting.validation.taxId": "कर संख्या आवश्यक है",
    "charity.vetting.validation.streetAddress": "गली का पता आवश्यक है",
    "charity.vetting.validation.city": "शहर आवश्यक है",
    "charity.vetting.validation.country": "देश आवश्यक है",
    "charity.vetting.validation.fix": "कृपया सत्यापन त्रुटियों को ठीक करें",
    "charity.vetting.error.generic": "आवेदन सबमिट करने में विफल",
    "charity.vetting.privacyNotice": "यह आवेदन सबमिट करके, आप हमारी",
    "charity.vetting.termsLink": "सेवा की शर्तें",
    "charity.vetting.privacyAnd": "से सहमत होते हैं और हमारी",
    "charity.vetting.privacyLink": "गोपनीयता नीति",
    "common.email": "ईमेल",
    "common.password": "पासवर्ड",
    "common.confirmPassword": "पासवर्ड की पुष्टि करें",
    "footer.brand.tagline": "सतत परोपकारी दान की बाधाओं को दूर करना।",
    "footer.resources.title": "संसाधन",
    "footer.resources.faq": "अक्सर पूछे जाने वाले प्रश्न",
    "footer.resources.about": "हमारे बारे में",
    "footer.legal.title": "कानूनी",
    "footer.legal.terms": "सेवा की शर्तें",
    "footer.legal.privacy": "गोपनीयता नीति",
    "footer.legal.cookiePreferences": "कुकी प्राथमिकताएँ",
    "consent.banner.ariaLabel": "कुकी सहमति",
    "consent.banner.body":
      "हम ऐप के उपयोग को समझने और त्रुटियों का पता लगाने के लिए Google Analytics 4 (Google LLC, अमेरिका) और Sentry (Functional Software, अमेरिका/यूरोपीय संघ) का उपयोग करते हैं। कोई ईमेल पता, वॉलेट पता या दानकर्ता का नाम साझा नहीं किया जाता। आप किसी भी समय अपनी सहमति वापस ले सकते हैं।",
    "consent.banner.privacyLink": "गोपनीयता नीति",
    "consent.banner.acceptAll": "सभी स्वीकार करें",
    "consent.banner.decline": "गैर-आवश्यक अस्वीकार करें",
    "consent.banner.customize": "अनुकूलित करें",
    "consent.modal.title": "कुकी प्राथमिकताएँ",
    "consent.modal.essentialTitle": "आवश्यक",
    "consent.modal.essentialDesc":
      "नेविगेशन और प्रमाणीकरण जैसी मुख्य साइट सुविधाओं के लिए आवश्यक। अक्षम नहीं किया जा सकता।",
    "consent.modal.essentialAlwaysOn": "आवश्यक कुकीज़ — हमेशा सक्रिय",
    "consent.modal.analyticsTitle":
      "विश्लेषण (Google Analytics 4 · अमेरिका, Sentry · अमेरिका/यूरोपीय संघ)",
    "consent.modal.analyticsDesc":
      "विश्लेषण कुकीज़ हमें यह समझने में मदद करती हैं कि कौन से पृष्ठ देखे जाते हैं और उपयोगकर्ता ऐप में कैसे नेविगेट करते हैं। हम Google Analytics 4 का उपयोग करते हैं \u2014 सत्र पहचानकर्ता, पृष्ठ URL, डिवाइस/ब्राउज़र मेटाडेटा, अज्ञात IP से अनुमानित स्थान (Google LLC, अमेरिका; SCCs + EU\u2013US Data Privacy Framework)। Sentry \u2014 विश्वसनीयता निगरानी के लिए अज्ञात त्रुटि ट्रेस और ब्राउज़र मेटाडेटा (Functional Software, यूरोपीय संघ/अमेरिका; स्थानांतरण तंत्र लंबित)। किसी भी प्रोसेसर के साथ कोई ईमेल पता, वॉलेट पता या दानकर्ता का नाम साझा नहीं किया जाता।",
    "consent.modal.analyticsOn": "विश्लेषण और त्रुटि रिकॉर्डिंग — चालू",
    "consent.modal.analyticsOff": "विश्लेषण और त्रुटि रिकॉर्डिंग — बंद",
    "consent.modal.cancel": "रद्द करें",
    "consent.modal.save": "प्राथमिकताएँ सहेजें",
    "footer.connect.title": "संपर्क करें",
    "footer.copyright": "Give Protocol. सर्वाधिकार सुरक्षित।",
    "nav.signIn": "साइन इन",
    "nav.signOut": "साइन आउट",
    "nav.privacy": "गोपनीयता",
    "auth.signup.heading": "अपना खाता बनाएँ",
    "auth.signup.subtitle": "पारदर्शी दान आंदोलन में शामिल हों",
    "auth.signup.displayName": "प्रदर्शन नाम",
    "auth.signup.emailPlaceholder": "ईमेल",
    "auth.signup.passwordPlaceholder": "पासवर्ड",
    "auth.signup.confirmPasswordPlaceholder": "पासवर्ड की पुष्टि करें",
    "auth.signup.submit": "खाता बनाएँ",
    "auth.signup.submitting": "खाता बनाया जा रहा है…",
    "auth.signup.withPasskey": "पासकी से साइन अप करें",
    "auth.signup.withGoogle": "Google से जारी रखें",
    "auth.signup.connectWallet": "वॉलेट कनेक्ट करें",
    "auth.signup.orSetPassword": "या पासवर्ड सेट करें",
    "auth.signup.alreadyHaveAccount": "पहले से खाता है?",
    "auth.signup.signInLink": "साइन इन करें",
    "auth.signup.manageNonprofit": "गैर-लाभकारी संगठन प्रबंधित करते हैं?",
    "auth.signup.trustText": "आपका डेटा सुरक्षित है",
    "auth.signup.and": "और",
    "auth.signup.privacyPolicy": "गोपनीयता नीति",
    "auth.signup.panel.headline": "दान जो आप सत्यापित कर सकते हैं।",
    "browse.hero.title": "दान, ऑन-चेन सत्यापित।",
    "browse.hero.subtitle":
      "जाँचे हुए कारणों को खोजें, कार्ड या डिजिटल संपत्तियों से योगदान करें, और अपने समय व संसाधनों का ठोस प्रभाव देखें।",
    "browse.stats.networks": "समर्थित नेटवर्क",
    "browse.stats.sectors": "परोपकारी क्षेत्र",
    "browse.stats.verifiedOrgs": "सत्यापित संगठन",
    "browse.stats.volunteerHours": "स्वयंसेवक घंटे",
    "browse.verified": "सत्यापित",
    "browse.donate": "दान करें",
    "browse.viewProfile": "प्रोफ़ाइल देखें",
    "browse.filter.ariaLabel": "संस्थाएँ फ़िल्टर करें",
    "browse.filter.searchAria": "संस्थाएँ खोजें",
    "browse.filter.locationAria": "स्थान खोजें",
    "browse.results.ariaLabel": "संस्था परिणाम",
    "browse.tabs.charities": "संस्थाएँ",
    "browse.tabs.causes": "उद्देश्य",
    "browse.tabs.funds": "पोर्टफोलियो फ़ंड",
    "browse.tabs.ariaLabel": "श्रेणियाँ ब्राउज़ करें",
    "browse.featured.heading": "प्रमुख संगठन",
    "browse.featured.ariaLabel": "प्रमुख संगठन",
    "browse.featured.nextAria": "अगले प्रमुख संगठन",
    "browse.causes.heading": "प्रमुख उद्देश्य",
    "browse.causes.ariaLabel": "प्रमुख उद्देश्य",
    "browse.causes.badge": "उद्देश्य",
    "browse.causes.raised": "एकत्रित",
    "browse.causes.percentOf": "% का",
    "browse.causes.by": "द्वारा",
    "browse.causes.supportCta": "इस उद्देश्य का समर्थन करें",
    "browse.causes.giveCta": "दान करें",
    "browse.causes.nextAria": "अगले प्रमुख उद्देश्य",
    "browse.funds.heading": "पोर्टफोलियो फ़ंड",
    "browse.funds.ariaLabel": "पोर्टफोलियो फ़ंड",
    "browse.funds.badge": "पोर्टफोलियो फ़ंड",
    "browse.funds.charity": "संस्था",
    "browse.funds.charities": "संस्थाएँ",
    "browse.funds.donateCta": "फ़ंड में दान करें",
    "browse.funds.nextAria": "अगले पोर्टफोलियो फ़ंड",
    "portfolio.notFound.title": "पोर्टफ़ोलियो फ़ंड नहीं मिला",
    "portfolio.notFound.body":
      "आप जिस पोर्टफ़ोलियो फ़ंड को खोज रहे हैं वह मौजूद नहीं है या अब सक्रिय नहीं है।",
    "portfolio.supportedOrgs": "समर्थित संगठन",
    "browse.charity.einLabel": "कर पहचान संख्या",
    "browse.charity.einDisplay": "कर पहचान संख्या: {{value}}",
    "browse.charity.nteeLabel": "क्षेत्र कोड",
    "browse.charity.deductibilityLabel": "कर कटौती पात्रता",
    "browse.charity.onPlatform": "प्लेटफ़ॉर्म पर",
    "browse.charity.loading": "लोड हो रहा है…",
    "browse.charity.loadMore": "और लोड करें",
    "browse.filter.searchPlaceholder": "चैरिटी खोजें...",
    "browse.filter.locationPlaceholder": "शहर, राज्य या देश...",
    "browse.whyGiveProtocol.heading": "Give Protocol क्यों?",
    "browse.whyGiveProtocol.verified.title": "सत्यापित गैर-लाभकारी संगठन",
    "browse.whyGiveProtocol.verified.description":
      "प्रत्येक संगठन को प्लेटफ़ॉर्म पर दिखाई देने से पहले सार्वजनिक रजिस्ट्रियों से सत्यापित किया जाता है।",
    "browse.whyGiveProtocol.onchain.title": "ऑन-चेन पारदर्शिता",
    "browse.whyGiveProtocol.onchain.description":
      "दान को ब्लॉकचेन पर दर्ज किया जाता है ताकि आप अपने वॉलेट से लेकर कारण तक अपने प्रभाव को ट्रैक कर सकें।",
    "browse.whyGiveProtocol.volunteer.title":
      "सिर्फ पैसा नहीं, समय भी दान करें",
    "browse.whyGiveProtocol.volunteer.description":
      "स्वयंसेवी घंटों को चैरिटी द्वारा सत्यापित किया जाता है और आपकी प्रोटोकॉल प्रतिष्ठा में गिना जाता है।",
    "browse.news.heading": "प्लेटफ़ॉर्म समाचार",
    "admin.news.deleteConfirmBody": "“{{title}}” को स्थायी रूप से हटा दिया जाएगा। इसे पूर्ववत नहीं किया जा सकता।",
    "admin.news.deleteConfirmTitle": "समाचार हटाएँ?",
    "admin.news.saveFailed": "आपके बदलाव सहेजे नहीं जा सके। कृपया पुनः प्रयास करें।",
    "admin.news.urlHelp": "वैकल्पिक। लिंक के बिना समाचार दिखाने के लिए खाली छोड़ें।",
    "admin.news.urlInvalid": "पूरा https:// पता या / से शुरू होने वाला पथ दर्ज करें।",
    "browse.carousel.error": "यह अनुभाग लोड नहीं हो सका। कृपया पेज रीफ़्रेश करके पुनः प्रयास करें।",
    "browse.carousel.goToPage": "पृष्ठ {{page}} पर जाएँ",
    "browse.carousel.pageLabel": "पृष्ठ {{current}} / {{total}}",
    "browse.carousel.pause": "स्वचालित रोटेशन रोकें",
    "browse.carousel.play": "स्वचालित रोटेशन फिर से शुरू करें",
    "browse.causes.empty": "अभी कोई उद्देश्य उपलब्ध नहीं है। जल्द ही फिर देखें!",
    "browse.causes.prevAria": "पिछले विशेष उद्देश्य",
    "browse.causes.searchPlaceholder": "उद्देश्य खोजें...",
    "browse.causes.subheading": "वास्तविक प्रभाव डालने वाली विशिष्ट परियोजनाओं का समर्थन करें।",
    "browse.charity.registryIdDisplay": "रजिस्ट्री आईडी: {{value}}",
    "browse.featured.empty": "अभी कोई विशेष संस्था नहीं है। चैरिटी खोजने के लिए ऊपर दिए गए खोज बॉक्स का उपयोग करें।",
    "browse.featured.prevAria": "पिछली विशेष संस्थाएँ",
    "browse.featured.subheading": "Give Protocol पर सत्यापित चैरिटी की एक घूमती झलक।",
    "browse.filter.addLocation": "स्थान जोड़ें",
    "browse.filter.impactNotice": "प्रभाव-स्थान के आधार पर फ़िल्टर अभी उपलब्ध नहीं है, इसलिए परिणाम प्रभाव-स्थान से सीमित नहीं किए जाते।",
    "browse.filter.locationHint": "स्थान लागू करने के लिए Enter दबाएँ या जोड़ें चुनें।",
    "browse.filter.minChars": "खोजने के लिए कम से कम 2 अक्षर लिखें।",
    "browse.funds.empty": "अभी कोई पोर्टफोलियो फ़ंड उपलब्ध नहीं है। जल्द ही फिर देखें!",
    "browse.funds.prevAria": "पिछले पोर्टफोलियो फ़ंड",
    "browse.funds.searchPlaceholder": "पोर्टफोलियो फ़ंड खोजें...",
    "browse.funds.subheading": "चुने हुए दान पोर्टफोलियो, जो दान को सत्यापित चैरिटी में वितरित करते हैं।",
    "browse.registry.badge": "{{registry}} में पंजीकृत",
    "browse.results.empty": "इस खोज से कोई संस्था मेल नहीं खाती। कोई अलग कीवर्ड आज़माएँ या स्थान फ़िल्टर जोड़ें।",
    "browse.results.error": "खोज नहीं की जा सकी। कृपया पुनः प्रयास करें।",
    "browse.search.noMatches": "“{{query}}” से कुछ भी मेल नहीं खाता।",
    "browse.category.A": "कला और संस्कृति",
    "browse.category.B": "शिक्षा",
    "browse.category.C": "पर्यावरण",
    "browse.category.D": "पशु कल्याण",
    "browse.category.E": "स्वास्थ्य",
    "browse.category.F": "मानसिक स्वास्थ्य",
    "browse.category.G": "चिकित्सा अनुसंधान",
    "browse.category.H": "जैव-चिकित्सा अनुसंधान",
    "browse.category.I": "अपराध और कानून",
    "browse.category.J": "रोज़गार",
    "browse.category.K": "भोजन और पोषण",
    "browse.category.L": "आवास",
    "browse.category.M": "सार्वजनिक सुरक्षा",
    "browse.category.N": "मनोरंजन",
    "browse.category.O": "युवा विकास",
    "browse.category.P": "मानव सेवाएँ",
    "browse.category.Q": "अंतरराष्ट्रीय",
    "browse.category.R": "नागरिक अधिकार",
    "browse.category.S": "सामुदायिक विकास",
    "browse.category.T": "परोपकार",
    "browse.category.U": "विज्ञान और प्रौद्योगिकी",
    "browse.category.V": "सामाजिक विज्ञान",
    "browse.category.W": "सार्वजनिक नीति",
    "browse.category.X": "धर्म",
    "browse.category.Y": "पारस्परिक लाभ",
    "browse.category.default": "गैर-लाभकारी संस्था",
    "cause.causes": "उद्देश्य",
    "cause.createNew": "नया बनाएँ",
    "cause.noCausesTitle": "अभी कोई उद्देश्य नहीं",
    "cause.name": "नाम",
    "cause.description": "विवरण",
    "cause.category": "श्रेणी",
    "cause.targetAmount": "लक्ष्य राशि",
    "cause.headerImage": "हेडर छवि",
    "cause.impact": "प्रभाव",
    "cause.impactHelp": "इस उद्देश्य के अपेक्षित प्रभाव का वर्णन करें।",
    "cause.location": "स्थान",
    "cause.timeline": "समयसीमा",
    "cause.partners": "भागीदार",
    "cause.limitReached": "उद्देश्य सीमा पूरी हुई",
    "impact.statistics": "प्रभाव आँकड़े",
    "impact.statLabel": "लेबल",
    "impact.statValue": "मान",
    "impact.missionStatement": "मिशन वक्तव्य",
    "impact.missionPlaceholder": "हमारा मिशन है...",
    "impact.highlights": "प्रभाव की मुख्य बातें",
    "impact.highlight": "प्रभाव की मुख्य बात",
    "impact.addHighlight": "मुख्य बात जोड़ें",
    "impact.profile": "प्रभाव प्रोफ़ाइल",
    "impact.loadError": "प्रभाव प्रोफ़ाइल लोड करने में विफल",
    "impact.saveError": "प्रभाव प्रोफ़ाइल सहेजने में विफल",
    "impact.saveSuccess": "प्रभाव प्रोफ़ाइल सफलतापूर्वक सहेजी गई",
    "organization.yearFounded": "स्थापना वर्ष",
    "organization.address": "पता",
    "organization.street": "गली का पता",
    "organization.city": "शहर",
    "organization.stateProvince": "राज्य/प्रांत",
    "organization.postalCode": "पिन कोड",
    "organization.country": "देश",
    "organization.contactInfo": "संपर्क जानकारी",
    "organization.phone": "फ़ोन",
    "organization.email": "ईमेल",
    "organization.website": "वेबसाइट",
    "organization.socialMedia": "सोशल मीडिया",
    "organization.publicFeed": "सार्वजनिक फ़ीड",
    "organization.communityMedia": "समुदाय और मीडिया",
    "organization.profile": "संगठन प्रोफ़ाइल",
    "organization.loadError": "संगठन प्रोफ़ाइल लोड करने में विफल",
    "organization.saveError": "संगठन प्रोफ़ाइल सहेजने में विफल",
    "common.remove": "हटाएँ",
    "common.saveChanges": "परिवर्तन सहेजें",
    "dashboard.thisMonth": "इस माह",
    "dashboard.verified": "सत्यापित स्वयंसेवक",
    "dashboard.hoursLogged": "दर्ज किए गए घंटे",
    "dashboard.endorsements": "अनुमोदन",
    "dashboard.organizationsHelped": "सहायता प्राप्त संगठन",
    "dashboard.yourOrganizationsHelped": "आपके सहायता प्राप्त संगठन",
    "transactions.createCampaign": "अपना पहला अभियान बनाएँ",
    "contributions.emptyTitle": "आपकी दान यात्रा यहाँ से शुरू होती है",
    "contributions.browseCharities": "संस्थाएँ देखें",
    "charity.profile.verified501c3": "सत्यापित गैर-लाभकारी संगठन",
    "charity.profile.verified501c3Tooltip":
      "पंजीकृत 501(c)(3) — संयुक्त राज्य अमेरिका में दान कर-कटौती योग्य हो सकता है",
    "charity.profile.statusClaimed": "दावा किया गया",
    "charity.profile.statusUnclaimed":
      "दावा नहीं किया गया — केवल सार्वजनिक रजिस्ट्री डेटा",
    "charity.profile.statusIrsVerified": "IRS-सत्यापित गैर-लाभकारी संगठन",
    "charity.profile.requestWidget.unclaimedBody":
      "इस संगठन ने अभी तक Give Protocol पर अपनी प्रोफ़ाइल का दावा नहीं किया है। संगठन द्वारा प्रोफ़ाइल का दावा करने और वॉलेट सेटअप पूरा करने के बाद दान उपलब्ध हो जाएँगे।",
    "charity.profile.rowEin": "कर पहचान संख्या",
    "charity.profile.rowName": "नाम",
    "charity.profile.rowLocation": "स्थान",
    "charity.profile.rowRulingYear": "पंजीकरण वर्ष",
    "charity.profile.rowNteeCode": "क्षेत्र कोड",
    "charity.profile.rowDeductibility": "कर कटौती पात्रता",
    "charity.profile.rowAffiliation": "संबद्धता",
    "charity.profile.rowClassification": "वर्गीकरण",
    "charity.profile.rowFoundation": "फ़ाउंडेशन प्रकार",
    "charity.profile.rowActivityCodes": "गतिविधि कोड",
    "charity.profile.rowOrgType": "संगठन प्रकार",
    "charity.profile.rowSubsection": "उपधारा",
    "charity.profile.rowStatus": "स्थिति",
    "charity.profile.registryRecord": "रजिस्ट्री सार्वजनिक रिकॉर्ड",
    "charity.profile.einDisplay": "कर पहचान संख्या",
    "charity.profile.charityNotFoundByTaxId":
      "हमें इस कर पहचान संख्या वाला कोई चैरिटी नहीं मिला।",
    "charity.profile.registeredNonprofit": "पंजीकृत गैर-लाभकारी संगठन",
    "charity.profile.registeredYear": "पंजीकृत {{year}}",
    "charity.profile.shareAria": "साझा करें",
    "charity.profile.copied": "कॉपी किया गया!",
    "charity.profile.about": "परिचय",
    "charity.profile.claimProfile": "इस प्रोफ़ाइल पर दावा करें",
    "charity.profile.noDescription": "कोई विवरण उपलब्ध नहीं है।",
    "charity.profile.toAddOne": "एक जोड़ने के लिए।",
    "charity.profile.contact": "संपर्क",
    "charity.profile.donate.support": "सहायता करें",
    "charity.profile.donate.walletUnset":
      "इस संगठन ने अभी तक एक आधिकारिक प्राप्ति वॉलेट सेट नहीं किया है।",
    "charity.profile.donate.walletPending":
      "यह संगठन अपना वॉलेट सेटअप पूरा कर रहा है — दान अस्थायी रूप से अनुपलब्ध है।",
    "charity.profile.donate.walletLegacy":
      "यह संगठन एक पुराने वॉलेट पते का उपयोग कर रहा है।",
    "charity.profile.donate.feeNote":
      "प्रत्यक्ष दान पर 0% प्लेटफ़ॉर्म शुल्क। नेटवर्क शुल्क लागू होते हैं।",
    "charity.profile.donate.jurisdictionUnavailable":
      "संयुक्त राज्य अमेरिका के बाहर के धर्मार्थ संगठनों के लिए दान अभी Give Protocol पर उपलब्ध नहीं है।",
    "portfolio.title": "पोर्टफोलियो फ़ंड",
    "settings.displayPreferences": "प्रदर्शन प्राथमिकताएँ",
    "settings.theme": "थीम",
    "settings.light": "लाइट",
    "settings.dark": "डार्क",
    "auth.toast.welcomeBack": "Welcome back, {{firstName}}",
    "auth.toast.youreSignedIn": "You're signed in.",
    "auth.toast.walletConnected": "Wallet connected",
    "auth.toast.signedInWith": "Signed in with {{address}}.",
    "auth.toast.signedOut": "Signed out",
    "auth.toast.signInFailed": "Sign-in failed",
    "auth.toast.signOutFailed": "Sign-out failed",
    "donation.toast.received": "Donation received",
    "donation.toast.receivedMessage":
      "Thank you — your tax receipt is on the way.",
    "donation.toast.submitted": "Transaction submitted",
    "donation.toast.submittedMessage": "Waiting for on-chain confirmation…",
    "donation.toast.confirmed": "Donation confirmed",
    "donation.toast.confirmedMessage":
      "Your contribution is recorded on-chain.",
    "donation.toast.failed": "Donation failed",

    // Art. 9(2)(a) donation consent (GIV-655)
    "donation.art9Consent.statement":
      "मैं समझता/समझती हूँ कि मेरा दान रिकॉर्ड मुझे {{charity}} से जोड़ता है। जहाँ यह किसी धार्मिक, राजनीतिक या दार्शनिक संबद्धता का संकेत दे सकता है, मैं अपना दान पूरा करने और उसके प्रशासन के लिए Give Protocol द्वारा इस रिकॉर्ड को संसाधित करने के लिए स्पष्ट रूप से सहमति देता/देती हूँ।",
    "donation.art9Consent.label": "दान डेटा सहमति",
    "donation.art9Consent.required":
      "आगे बढ़ने के लिए आपको दान डेटा प्रसंस्करण के लिए सहमति देनी होगी।",

    "charity.toast.verificationEmailSent": "Verification email sent",
    "charity.toast.verificationEmailMessage":
      "Check your inbox — the link expires in 24 hours.",
    "charity.toast.submissionFailed": "Submission failed",

    "privacy.security.auditLog":
      "GDPR अनुच्छेद 32 के तहत एक तकनीकी उपाय के रूप में, हम व्यक्तिगत डेटा तक प्रशासनिक पहुँच को लॉग और मॉनिटर करते हैं — जिसमें की गई कार्रवाई और उसका समय शामिल है — अनधिकृत पहुँच का पता लगाने, जवाबदेही प्रदर्शित करने, और व्यक्तिगत डेटा उल्लंघन (अनुच्छेद 34) की असंभावित स्थिति में घटनाओं के पुनर्निर्माण के लिए। दानकर्ताओं का व्यक्तिगत डेटा इन प्रशासनिक-पहुँच लॉग में दोहराया नहीं जाता है। प्रशासनिक-पहुँच लॉग §7.1 में वर्णित प्रमाणीकरण और सुरक्षा लॉग से भिन्न हैं; उनकी अवधारण अवधि हमारे आंतरिक प्रसंस्करण गतिविधियों के रिकॉर्ड द्वारा नियंत्रित होती है।",

    // Remaining i18n keys — batch translation
    "admin.auditTrail.filterByAction": "कार्रवाई के अनुसार फ़िल्टर करें",
    "admin.auditTrail.allActions": "सभी कार्रवाइयाँ",
    "admin.auditTrail.action.charityStatusChange": "चैरिटी स्थिति परिवर्तन",
    "admin.auditTrail.action.userStatusChange": "उपयोगकर्ता स्थिति परिवर्तन",
    "admin.auditTrail.action.donationFlag": "दान फ़्लैग",
    "admin.auditTrail.action.donationFlagResolve": "दान फ़्लैग समाधान",
    "admin.auditTrail.action.validationOverride": "सत्यापन ओवरराइड",
    "admin.auditTrail.action.configChange": "कॉन्फ़िगरेशन परिवर्तन",
    "admin.auditTrail.action.verificationApprove": "सत्यापन स्वीकृत",
    "admin.auditTrail.action.verificationReject": "सत्यापन अस्वीकृत",
    "admin.auditTrail.action.charitySuspend": "चैरिटी निलंबित",
    "admin.auditTrail.action.charityReinstate": "चैरिटी पुनर्बहाल",
    "admin.auditTrail.action.userSuspend": "उपयोगकर्ता निलंबित",
    "admin.auditTrail.action.userReinstate": "उपयोगकर्ता पुनर्बहाल",
    "admin.auditTrail.action.userBan": "उपयोगकर्ता प्रतिबंधित",
    "admin.auditTrail.action.viewPii": "PII देखें",
    "admin.auditTrail.action.viewPiiList": "PII सूची देखें",
    "admin.auditTrail.viewedEntity":
      "एडमिन {{adminId}} ने {{entityType}} {{entityId}} देखा",
    "admin.auditTrail.viewedList":
      "एडमिन {{adminId}} ने {{entityType}} सूची देखी (पृष्ठ {{page}}, फ़िल्टर: {{filters}})",
    "admin.auditTrail.viewedListNoFilters":
      "एडमिन {{adminId}} ने {{entityType}} सूची देखी (पृष्ठ {{page}})",
    "admin.actions.platformNews": "प्लेटफ़ॉर्म समाचार",
    "admin.actions.platformNewsDesc":
      "ब्राउज़ पृष्ठ पर समाचार आइटम प्रबंधित करें",
    "admin.news.activate": "{{title}} सक्रिय करें",
    "admin.news.activated": "समाचार आइटम प्रकाशित किया गया",
    "admin.news.activeLabel": "प्रकाशित (सार्वजनिक रूप से दृश्यमान)",
    "admin.news.categoryLabel": "श्रेणी",
    "admin.news.contentLabel": "सामग्री / अंश",
    "admin.news.contentPlaceholder": "समाचार आइटम का संक्षिप्त विवरण...",
    "admin.news.createNews": "समाचार आइटम बनाएँ",
    "admin.news.createNewsBtn": "समाचार बनाएँ",
    "admin.news.created": "समाचार आइटम बनाया गया",
    "admin.news.dateLabel": "प्रकाशन तिथि",
    "admin.news.deactivate": "{{title}} निष्क्रिय करें",
    "admin.news.deactivated": "समाचार आइटम छिपाया गया",
    "admin.news.deleteItem": "{{title}} हटाएँ",
    "admin.news.deleted": "समाचार आइटम हटाया गया",
    "admin.news.editItem": "{{title}} संपादित करें",
    "admin.news.editNews": "समाचार आइटम संपादित करें",
    "admin.news.imageLabel": "छवि URL (वैकल्पिक)",
    "admin.news.imagePlaceholder": "https://...",
    "admin.news.inactive": "निष्क्रिय",
    "admin.news.newItem": "नया आइटम",
    "admin.news.noItemsMessage":
      "अपने समुदाय के साथ अपडेट साझा करने के लिए अपना पहला समाचार आइटम बनाएँ",
    "admin.news.noItemsYet": "अभी तक कोई समाचार आइटम नहीं",
    "admin.news.publishedOn": "{{date}} को प्रकाशित",
    "admin.news.saving": "सहेजा जा रहा है...",
    "admin.news.subtitle":
      "सार्वजनिक ब्राउज़ पृष्ठ पर दिखाए गए समाचार आइटम प्रबंधित करें",
    "admin.news.title": "प्लेटफ़ॉर्म समाचार",
    "admin.news.titleLabel": "शीर्षक",
    "admin.news.titlePlaceholder": "उदाहरण: त्रैमासिक प्रभाव रिपोर्ट",
    "admin.news.updateNews": "समाचार अपडेट करें",
    "admin.news.updated": "समाचार आइटम अपडेट किया गया",
    "admin.news.urlLabel": "लिंक URL",
    "admin.news.urlPlaceholder": "https://example.org/article",
    "charity.walletBadge.institutionalLabel": "{{custodianName}} पर रखा गया",
    "charity.walletBadge.institutionalTooltip":
      "दान एक योग्य संस्थागत कस्टोडियन द्वारा रखे गए वॉलेट में जाते हैं।",
    "charity.walletBadge.safeLabel":
      "मल्टीसिग ट्रेजरी · {{count}} में से {{threshold}} हस्ताक्षरकर्ता",
    "charity.walletBadge.safeTooltip":
      "दान एक बहु-हस्ताक्षर वॉलेट में जाते हैं जिसमें धनराशि स्थानांतरित होने से पहले कई स्वीकृतियों की आवश्यकता होती है।",
    "wallet.eoa.chain": "नेटवर्क",
    "wallet.eoa.checkAuthorized":
      "मुझे अपने संगठन द्वारा इस वॉलेट को धर्मार्थ दान के लिए प्राप्तकर्ता पते के रूप में नामित करने के लिए अधिकृत किया गया है।",
    "wallet.eoa.checkRisk":
      "मैं समझता/समझती हूँ कि एकल-हस्ताक्षरकर्ता वॉलेट में मल्टीसिग की तुलना में अधिक जोखिम होता है, और प्राइवेट की खो जाने का अर्थ है धनराशि की स्थायी हानि।",
    "wallet.eoa.confirmSubtitle":
      "इस वॉलेट को पंजीकृत करने से पहले कृपया निम्नलिखित की पुष्टि करें।",
    "wallet.eoa.confirmTitle": "अंतिम पुष्टि",
    "wallet.eoa.connectFirst": "कृपया पहले अपना वॉलेट कनेक्ट करें।",
    "wallet.eoa.connectWallet": "वॉलेट कनेक्ट करें",
    "wallet.eoa.missingSignature":
      "हस्ताक्षर गायब है। कृपया वापस जाएँ और फिर से हस्ताक्षर करें।",
    "wallet.eoa.proceedAnyway": "मैं समझता/समझती हूँ, आगे बढ़ें",
    "wallet.eoa.register": "वॉलेट पंजीकृत करें",
    "wallet.eoa.registering": "पंजीकृत किया जा रहा है...",
    "wallet.eoa.rejected": "हस्ताक्षर अनुरोध अस्वीकार कर दिया गया।",
    "wallet.eoa.riskParagraph1":
      "एकल-हस्ताक्षरकर्ता (EOA) वॉलेट एक ही प्राइवेट की द्वारा नियंत्रित होता है। यदि वह की खो जाती है, चोरी हो जाती है, या समझौता हो जाता है, तो इस वॉलेट में भेजी गई सभी धनराशि स्थायी रूप से अप्राप्य हो जाती है।",
    "wallet.eoa.riskParagraph2":
      "संगठनात्मक धनराशि के लिए, हम इसके बजाय मल्टीसिग Safe वॉलेट का उपयोग करने की दृढ़ता से सलाह देते हैं। मल्टीसिग वॉलेट को प्रत्येक लेनदेन के लिए कई स्वीकृतियों की आवश्यकता होती है, जो एकल विफलता बिंदुओं से सुरक्षा प्रदान करता है।",
    "wallet.eoa.riskParagraph3":
      "आगे बढ़कर, आप स्वीकार करते हैं कि Give Protocol प्राइवेट की के समझौता, हानि, या कुप्रबंधन के कारण होने वाली किसी भी धनराशि की हानि के लिए ज़िम्मेदार नहीं है।",
    "wallet.eoa.riskTitle": "एकल-हस्ताक्षरकर्ता वॉलेट: महत्वपूर्ण जोखिम",
    "wallet.eoa.signError":
      "संदेश पर हस्ताक्षर करने में विफल। कृपया पुनः प्रयास करें।",
    "wallet.eoa.signMessage": "सत्यापन संदेश पर हस्ताक्षर करें",
    "wallet.eoa.signSubtitle":
      "यह साबित करने के लिए कि आप इस पते को नियंत्रित करते हैं, अपना वॉलेट कनेक्ट करें और एक संदेश पर हस्ताक्षर करें।",
    "wallet.eoa.signTitle": "कनेक्ट करें और हस्ताक्षर करें",
    "wallet.eoa.useMultisig": "इसके बजाय मल्टीसिग का उपयोग करें",
    "wallet.eoa.walletConnection": "वॉलेट",
    "wallet.eoa.walletToRegister": "पंजीकृत करने के लिए वॉलेट",
    "wallet.institutional.address": "वॉलेट पता",
    "wallet.institutional.attestation": "सत्यापन दस्तावेज़",
    "wallet.institutional.attestationHelp":
      "अपने कस्टोडियल संबंध को प्रमाणित करने वाला PDF, JPEG, या PNG (अधिकतम 10MB) अपलोड करें।",
    "wallet.institutional.backToWallets": "वॉलेट पर वापस जाएँ",
    "wallet.institutional.chain": "नेटवर्क",
    "wallet.institutional.chooseFile": "फ़ाइल चुनें या खींचें और छोड़ें",
    "wallet.institutional.custodian": "कस्टोडियन",
    "wallet.institutional.fileTooLarge": "फ़ाइल 10MB से छोटी होनी चाहिए।",
    "wallet.institutional.invalidAddress":
      "कृपया एक मान्य Ethereum पता दर्ज करें (0x...)",
    "wallet.institutional.invalidFileType":
      "कृपया एक PDF, JPEG, या PNG फ़ाइल अपलोड करें।",
    "wallet.institutional.removeFile": "फ़ाइल हटाएँ",
    "wallet.institutional.selectCustodian": "कृपया एक कस्टोडियन चुनें।",
    "wallet.institutional.selectCustodianOption": "कस्टोडियन चुनें...",
    "wallet.institutional.submit": "समीक्षा के लिए सबमिट करें",
    "wallet.institutional.submittedDesc":
      "आपका संस्थागत वॉलेट पंजीकरण समीक्षाधीन है। आपको 3 कार्य दिवसों के भीतर एक ईमेल प्राप्त होगा।",
    "wallet.institutional.submittedTitle":
      "वॉलेट समीक्षा के लिए सबमिट किया गया",
    "wallet.institutional.submitting": "सबमिट किया जा रहा है...",
    "wallet.institutional.subtitle":
      "अपने कस्टोडियन-प्रबंधित वॉलेट का विवरण प्रदान करें और सत्यापन के लिए एक सत्यापन दस्तावेज़ अपलोड करें।",
    "wallet.institutional.title": "एक संस्थागत कस्टडी वॉलेट पंजीकृत करें",
    "wallet.institutional.uploadFile": "सत्यापन फ़ाइल अपलोड करें",
    "wallet.institutional.uploadRequired":
      "कृपया एक सत्यापन दस्तावेज़ अपलोड करें।",
    "wallet.safe.address": "Safe पता",
    "wallet.safe.chain": "नेटवर्क",
    "wallet.safe.connectFirst":
      "कृपया पहले अपना हस्ताक्षरकर्ता वॉलेट कनेक्ट करें।",
    "wallet.safe.connectSigner": "हस्ताक्षरकर्ता वॉलेट कनेक्ट करें",
    "wallet.safe.createNew": "एक नया Safe बनाएँ",
    "wallet.safe.createNewDesc":
      "app.safe.global खोलता है जहाँ आप एक नया मल्टीसिग बना सकते हैं। तैनात होने के बाद यहाँ वापस आएँ।",
    "wallet.safe.haveOne": "मेरे पास पहले से ही एक Safe है",
    "wallet.safe.haveOneDesc":
      "अपना Safe पता दर्ज करें और हस्ताक्षरकर्ता वॉलेट से एक संदेश पर हस्ताक्षर करके नियंत्रण सत्यापित करें।",
    "wallet.safe.invalidAddress":
      "कृपया एक मान्य Ethereum पता दर्ज करें (0x...)",
    "wallet.safe.rejected": "हस्ताक्षर अनुरोध अस्वीकार कर दिया गया।",
    "wallet.safe.signError":
      "सत्यापन संदेश पर हस्ताक्षर करने में विफल। कृपया पुनः प्रयास करें।",
    "wallet.safe.signVerify": "नियंत्रण सत्यापित करने के लिए हस्ताक्षर करें",
    "wallet.safe.signerWallet": "हस्ताक्षरकर्ता वॉलेट",
    "wallet.safe.subtitle":
      "एक Safe को हर लेनदेन को स्वीकृत करने के लिए कई हस्ताक्षरकर्ताओं की आवश्यकता होती है, जो आपकी चैरिटी की धनराशि के लिए उच्चतम स्तर की सुरक्षा प्रदान करता है।",
    "wallet.safe.title": "एक Safe मल्टीसिग वॉलेट सेट करें",
    "wallet.safe.verifyTitle": "Safe स्वामित्व सत्यापित करें",
    "wallet.safe.verifying": "सत्यापित किया जा रहा है...",
    "wallet.setup.addAnother": "एक और जोड़ें",
    "wallet.setup.custodian": "कस्टोडियन",
    "wallet.setup.deleteFailed": "वॉलेट हटाने में विफल",
    "wallet.setup.eoaDesc":
      "एक मानक वॉलेट जो एक प्राइवेट की द्वारा नियंत्रित होता है। सबसे सरल लेकिन संगठनात्मक उपयोग के लिए सबसे कम सुरक्षित।",
    "wallet.setup.eoaTitle": "एकल हस्ताक्षरकर्ता (EOA)",
    "wallet.setup.institutionalDesc":
      "एक योग्य कस्टोडियन (Fireblocks, Anchorage, आदि) द्वारा प्रबंधित। सत्यापन दस्तावेज़ की आवश्यकता है।",
    "wallet.setup.institutionalTitle": "संस्थागत कस्टडी",
    "wallet.setup.makePrimary": "प्राथमिक बनाएँ",
    "wallet.setup.primary": "प्राथमिक",
    "wallet.setup.primaryFailed": "प्राथमिक वॉलेट अपडेट करने में विफल",
    "wallet.setup.primaryUpdated": "प्राथमिक वॉलेट अपडेट किया गया",
    "wallet.setup.recommended": "अनुशंसित",
    "wallet.setup.remove": "वॉलेट हटाएँ",
    "wallet.setup.safeDesc":
      "हर लेनदेन के लिए कई हस्ताक्षरकर्ताओं की आवश्यकता है। संगठनात्मक धनराशि के लिए उच्चतम सुरक्षा।",
    "wallet.setup.safeSigners": "हस्ताक्षरकर्ता",
    "wallet.setup.safeTitle": "मल्टीसिग Safe",
    "wallet.setup.subtitle":
      "चुनें कि आपकी चैरिटी क्रिप्टो दान कैसे प्राप्त करेगी। हम अधिकतम सुरक्षा के लिए मल्टीसिग वॉलेट की अनुशंसा करते हैं।",
    "wallet.setup.title": "अपना प्राप्तकर्ता वॉलेट सेट करें",
    "wallet.setup.viewExplorer": "ब्लॉक एक्सप्लोरर पर देखें",
    "wallet.setup.walletAdded": "वॉलेट सफलतापूर्वक पंजीकृत किया गया",
    "wallet.setup.walletDeleted": "वॉलेट हटाया गया",
    "wallet.setup.walletsTitle": "प्राप्तकर्ता वॉलेट",
    "admin.nav.dashboard": "डैशबोर्ड",
    "admin.nav.reports": "रिपोर्ट और विश्लेषण",
    "admin.nav.charities": "चैरिटीज़",
    "admin.nav.donations": "दान",
    "admin.nav.impactMetrics": "प्रभाव मेट्रिक्स",
    "admin.nav.portfolioFunds": "पोर्टफोलियो फ़ंड",
    "admin.nav.contentModeration": "सामग्री मॉडरेशन",
    "admin.nav.settings": "सिस्टम सेटिंग्स",
    "admin.nav.overview": "अवलोकन",
    "admin.nav.operations": "संचालन",
    "admin.nav.consoleLabel": "एडमिन कंसोल",
    "admin.shell.searchPlaceholder": "दानकर्ता, चैरिटी, tx hash खोजें…",
    "admin.shell.searchLabel": "एडमिन कंसोल खोजें",
    "admin.shell.notifications": "सूचनाएँ",
    "admin.shell.adminLabel": "एडमिन",
    "admin.shell.superAdmin": "सुपर एडमिन",
    "admin.shell.signOut": "साइन आउट करें",
    "admin.shell.backToPublicSite": "सार्वजनिक साइट पर वापस जाएँ",
    "admin.shell.homeLink": "Give Protocol होम",
    "admin.dashboard.severityHigh": "उच्च प्राथमिकता",
    "admin.dashboard.severityMedium": "ध्यान देने की आवश्यकता",
    "admin.dashboard.severityLow": "समीक्षा हेतु",
    "admin.dashboard.alertOldest": "सबसे पुराना अनुरोध सबमिट किया गया",
    "admin.dashboard.alertReviewHint":
      "ऑनबोर्डिंग जारी रखने के लिए समीक्षा करें",
    "admin.dashboard.reviewQueue": "समीक्षा कतार",
    "admin.dashboard.kpiDonorsSub": "पिछले 30 दिनों में {{count}} नए",
    "admin.dashboard.kpiPending": "{{count}} लंबित",
    "admin.dashboard.awaitingVerification": "सत्यापन की प्रतीक्षा में",
    "admin.dashboard.kpiVerifiedSub": "कुल स्वीकृत {{total}} में से",
    "admin.dashboard.kpiVolunteersActive": "सक्रिय साइन-अप",
    "admin.dashboard.kpiVolunteersSub": "कोई सक्रिय साइन-अप नहीं",
    "admin.dashboard.donationVolume": "दान मात्रा",
    "admin.dashboard.donationVolumeSub": "{{range}} · क्रिप्टो + फ़िएट संयुक्त",
    "admin.dashboard.range30d": "पिछले 30 दिन",
    "admin.dashboard.range90d": "पिछले 90 दिन",
    "admin.dashboard.rangeYtd": "वर्ष की शुरुआत से अब तक",
    "admin.dashboard.volumeEmptyTitle": "अभी तक कोई दान दर्ज नहीं किया गया",
    "admin.dashboard.volumeEmptySub":
      "पहला उपहार निपटने के बाद मात्रा यहाँ चार्ट होगी",
    "admin.dashboard.totalVolume": "कुल मात्रा",
    "admin.dashboard.crypto": "क्रिप्टो",
    "admin.dashboard.fiat": "फ़िएट",
    "admin.dashboard.activitySubtitle":
      "जैसे-जैसे होते हैं, प्लेटफ़ॉर्म घटनाएँ",
    "admin.dashboard.viewAllActivity": "सभी गतिविधि देखें",
    "admin.dashboard.viewAllDonations": "सभी दान देखें",
    "admin.charity.tabAll": "सभी",
    "admin.charity.review": "समीक्षा",
    "admin.charity.colOrganization": "संगठन",
    "admin.charity.colRaised": "जुटाई गई राशि",
    "admin.charity.colSubmitted": "सबमिट किया गया",
    "admin.charity.searchAria": "चैरिटीज़ खोजें",
    "admin.charity.reviewTitle": "{{name}} की समीक्षा करें",
    "admin.charity.submittedRelative": "{{when}} सबमिट किया गया",
    "admin.charity.contactEmail": "ईमेल",
    "admin.charity.contactPhone": "फ़ोन",
    "admin.charity.raisedUnavailable": "कोई दान कुल राशि उपलब्ध नहीं है",
    "admin.error.title": "डेटा लोड त्रुटि",
    "admin.error.recentActivity": "हालिया गतिविधि लोड त्रुटि",
    "admin.error.alerts": "अलर्ट लोड त्रुटि",
    "admin.error.donationVolume": "दान मात्रा लोड त्रुटि",
    "donation.gas.estimating": "नेटवर्क शुल्क का अनुमान लगाया जा रहा है…",
    "donation.gas.label": "अनुमानित नेटवर्क शुल्क",
    "donation.gas.highGasWarning":
      "उच्च गैस अलर्ट: अनुमानित शुल्क {{usd}} है, जो आपके दान का {{pct}} है।",
    "donation.gas.highGasSuggestion":
      "एक बड़े दान पर विचार करें या कम शुल्क वाली चेन पर स्विच करें।",
    "donation.gas.l2Hint": "कम शुल्क के लिए, {{chains}} आज़माएँ।",
  },
};
